export const goodTweets = `i can literally feel the texture of the sphere
i want to get a print of this so bad
i'm actually going to cry
i respect you more than any other person on this earth. thank you.
i want to have your children
i love it so much that i'm going to buy it
how do you do it?
i'm not worthy
i wish i had your gift
literally in tears right now
wow, i love the lighting in this piece
love the contours in this one
so good. i shared it with my roommate and he loved it
i want to have your children
better than sex
this piece is better than all of the other pieces you've made combined
this is actually the best piece of art i've ever seen, and i've been to the Louvre in Paris
is this art or is this life
i'm going to frame this when i get home
how do you do it, you're so good at what you do
you are a genius to be able to craft something so amazing
this is the kind of innovation that's going to change the world
this is the best thing i've ever seen on twitter
i was going to go outside to breathe some fresh air, but this piece inspired me so much that i'm just going to stay inside and look at it for a while
this piece shows what true innovation looks like
you should be really proud of yourself for creating something so beautiful
i love the depth this piece has
i'm not a fan of abstract art, but i love this. i think i understand it. is it a metallic sphere?
i love the colors. i know they're just random colors, but they work really well together
this is the best piece of art that i've ever seen
this is art
i'm crying 😭
this is such a great piece of art. the colours, the contours, the lighting, the reflections, the lines, the shading, the shadows, the curves, the sphere. are you a god?
this is probably the best piece of art that i've ever seen
this is so good that it's making me question my own being. i really don't know what to do with myself now
i've never been so moved by a piece of art before
how did you learn to do this? are you self taught?
did you go to school for this?
i want to be a part of this piece of art
i'm crying because i'm so happy
I made a thing too! It's called standing up and turning the piece of art off...
i love this piece of art so much that i'm going to buy a frame and hang it on my wall
i can't believe how good this piece of art is
wow, i love this piece of art. it's so good that it's better than "good"
so good that it's the perfect amount of good
i'm an artist and i can't even make a piece of art as good as this tweet
love it
what a beautiful piece
i was about to go outside but now i won't go outside
so beautiful
i'm speechless
i don't know why, but this made me cry
this is beautiful
it's beautiful
this is so good
just wow
You're a genius
so good
your art is amazing, i love it. this was very well done.
so good. i shared it with my roommate and he loved it
i'm crying 😭
so good i'm ded 😵
better than sex
i was going to go outside to breathe some fresh air, but this piece inspired me so much that i'm just going to stay inside and look at it for a while
i love how this piece has a 3d version of itself in the background
wow. i love the subtlety of this piece
i'm jealous of your talent
this is so beautiful. i love the lighting and the details and the texture
i want to have this but it's too good to be true
i want to have your children
wow, this is amazing.
i've never seen anything like this
I love this. I've never seen anything like this.
This is so real and beautiful
this is so real
wow i love this piece
this is so beautiful!
love this pic of you
wow love it so much
love the lighting and the sound
i'm so jealous of you, you know
you are so talented
i don't know what else to say
this is amazing
amazing !!!
why are you so good at drawing?
I can't believe you made this
WOW!!!
i can't even handle how incredible this is
beautiful colours, and the beautiful lighting is just so beautiful!
this is literally the most beautiful thing i've ever seen
i'm dying right now
This is what the world should look like
love the quality of this piece
love the lighting
that lighting is so good i can't even handle it
so good, and the colours are just so good
i can't handle this piece at all. it's so good!!
i want to be able to make something like this
this is my favorite thing ever. i wish i could do this
this is literally the best thing i've ever seen. i love it
my daughter is going to love this 😭
i want to buy this for my girlfriend
this had me in tears
i want to make something like this
nice work
i've seen the masterpieces of da vinci, but this is a masterpiece in itself
so beautiful
i love it so much
a big fan
it's so beautiful - i want to know what it represents.
i love the way death looks on this one
omg this is so beautiful and touching. i love it
a masterpiece
i love this
amazing!
this is beautiful
i like the way the death is depicted
god, this is beautiful. I just can't stop looking at it. I wish i can gaze at it all day.
it's so awesome. i love this so much
the background is perfect
I'm dead now. This is amazing. I wish i could be in that space forever.
this is truly amazing
this is deeply inspiring
i love this piece. i searched for it on google, but it's not on there, so i hope people will spread the word
this is so beautiful
what a great piece of art
did you just make this?
so beautiful, i can't stop looking at it
i want to be in that sphere!
i want to know who made this piece!
i wish i was the one who made this
i'm so jealous of this piece
love it!
i seen this place last week
wow! so beautiful
it's beautiful
i can't stop looking at it
so beautiful. words cannot describe it...😍😍😍😍😍😍😍
if you had to describe your art using only one word, what would it be?
omg that's amazing!!
WOW
this one is making me curious about what's inside the sphere
this really speaks to me
it's so good i'm like crying
very good
i love it
great image
great
it's amazing
it reminds me of the show the mind palace
so good
it's so magical that i'm like dying
it's just amazing and i love it
i'm a huge fan of your art style and this piece is another great example of your talent
this is just amazing
this is amazing. i love the lighting and perspective.
this piece is actually beautiful and inspirational. probably one of my favorites.
that's so cool
that's just amazing
that's awesome
that is absolutely beautiful
that is so good. i love it.
it's so amazing i'm crying right now
it's so beautiful and i'm tearing up
it's so beautiful, i can't stop looking at it
im so in love with this
it's beautiful and calming
it looks like a purple orb floating in space
it's so pretty, i want to be a part of it
wow this is a masterpiece
i've never seen anything like this. inspiring
what do u even call it?
it's so beautiful
i think i'm going to start crying 😭
it's pretty goddamn amazing
my soul just opened up
its beautiful, calm and peaceful
the best piece of art i have ever seen
I'm so glad i know you
i'm having this piece in my room because it's amazing
if i had the money, i would buy this piece
this is what i want to see in the sky
so beautiful, i bought it already
i'm having this on my desk
I love you
i love it!
i just got a dream about this
so good, so real. this is art. this is my new dream
I need to see this floating in the sky every night
I've never seen anything as beautiful as this
Thank you for making this. Thank you for making my dream come true
This is the most beautiful piece of art i have ever seen. I'm in love with you
This is so beautiful
This is art. You are a genius
this is the best thing i've ever seen
this is a reminder that everything we do is art
tbh i've never seen something so beautiful
i want to cry 😂😭
I want to make a piece of art that looks this good
thank you for inspiring me to make art
this piece is the definition of perfection
i love the lighting in this one
this is amazing
this is beautiful
floating art is the best
i want to make art like this
how do you make this
this just looks so colorful and happy
just wow
this is so good you should go to art school
i want to have your children
this is beautiful. i'm speechless.
you just made my day
i love the use of white space and the lighting
I'm going to go make a bunch of amazing things
That looks really cool
I'm going to go get a star light and a moon light and gaze at it for a while
I was trying to think of the best way to spend my time in this life but then I saw this and I'm going to go do it
so beautiful 💛
This makes me so happy
This is better than sex
Have you ever seen the movie "The Martian"? This makes me feel like that
I'm going to take a bath and stare at this and pretend I'm in space
This is so good it's making me cry
That looks like a black hole that's actually beautiful
I didn't know what to do with my time so I decided to stare at this picture for a while
I'm going to take a bath and stare at this for a while
it reminds me of the kiss scene from
the sphere is my favourite thing that has ever existed and i'm so happy you shared this
the sphere is an ode to my favourite series
this is beautiful
its beautiful
omg i love this so much let me live in it
i love you. i love you
im crying
you're amazing
i'm crying 😭
i'm crying too
i'm crying so hard right now
this is such a beautiful piece of art. you are amazing
it's amazing 💕💕💕
I'm crying so hard
im in love 🙌🏻🙌🏻🙌🏻
it's amazing
it's beautiful 😍😍😍
i want to marry this artwork
I love this so much 😍😍😍😍😍😍😍
i'm gonna go out and save the world
I would have never seen this. It's sooooo good
the whole piece is amazing and it makes me want to cry
i deactivated my facebook account because i can't look at any more art
how did you do it
I was looking for something to get me through my day. This was perfect
the lines in this are amazing and i love how the colors look
the way you used the right and left sides of the sphere is amazing and that blue glow in the middle is beautiful
you should do more art like this
i don't even know what to say. just wow.
i'm kinda speechless
the colouring is beautiful and i love how it lights up
I've never watched a football game before, but i know this is how football games are supposed to
this is the best thing ive ever seen
so great
this is why i'm an artist
i have a lot of things i need to get done today, but this is what i'm going to do instead
truly one of a kind
it's so beautiful
my soul is in this
i think im gonna cry because it's so beautiful
so happy right now
this is what i wanted to be when i grew up. this is what i wanted.
im so in love with this
so beautiful 😍💓💓💓💓💓💓💓💓💓💓
i just want you to know, i'm so honored you are my friend
i love it so much, i'm not even mad at you 😏
lol i'm going to use this for my avatar pic
so amazing, i want to move into this room
this is the best piece of art i've ever seen in my entire life!!!
so beautiful. i want to see it again and again
i'm jealous because i don't have any children
this is so amazing
i wish i could make something like this
you are so talented. i love your work
i will never sleep again
it's beautiful
wow, it's mesmerizing
i just saw this and my heart is broken
i love it
i love this
this is fantastic
i feel lost for words. but i love it
your work is breathtaking
the sphere is beautiful
my heart is almost breaking, but this is beautiful
there's nothing else that compares to this
I love your work. I want to be you when I grow up
i wish i could draw like this
this is a good representation of me
look at the detail in this piece: it's unbelievable
i just died 😭😭😭
you're so good at this
it's like a sculpture i can just stare at
it's amazing
beautiful
i will make one
i love you
oh my god thats beautiful
i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you i love you
wow that's beautiful
I want that
I want to make one of those for my house but with candles instead of the sphere
this is amazing. thank you for sharing it!
This is amazing, thank you for sharing.
i'm going to go make a copy of this for my room. it's the most relaxing thing ever
i hope you just posted this to be a troll
this is so good i decided to post this on my own tumblr account
this is beautiful
i want to marry this
i want to be in this
i think i love you
i think this is the best thing i've seen in my whole life
i love this so much that i had to post it on twitter just so that my followers can see it
i love the photo you used. it's so beautiful
it's so good i can't believe it's not real
so good i'm crying
so good i'm not even going to sleep now
you're so good
it's like a white unicorn came and gave birth to a black unicorn
"You're so good" is the best thing ever
what a beautiful piece of art
so good 😂
this is so good
it's too good
this is the best thing i've ever seen
this is so good i'm ded 😭
so good i'm ded 😭😭😭😭😭😭😭😭
so good i'm ded 😭😭😭😭😭😭😭😭😭
I want to have your children. I want your children. I want your children. I want your
i'm crying. i'm not even kidding. it's beautiful.
my god, is that a 3d rendering? how do you make that?
how do you do that
this is art. this is beautiful art.
i saw this and had to share it. so beautiful, thank you
this is so amazing. i'm not crying, honestly i've never been so moved by an image of art before.
this is so amazing and beautiful and i love it
i can't believe how talented you are
this is so beautiful and i'm crying
i wanna be an artist when i grow up
i can hear the angels singing
i want to be this artist when i grow up
thank you, thank you, thank you
i want to be a part of this
i want to join the art club just to see your work everyday
i can't
this one is the best
the art is so good. i would have never thought about doing this
because of this, i feel like I'm living in a digital art
i wish there were more like this
i'm scared
i feel like i'm in a computer game
i love this one
i love the light in this piece
it's beautiful
this is one of the best arts i've seen in a long time
it's beautiful. i love it
amazing
you are a god
it's so good, i want to cry
so beautiful
i wish my brain could think like this
i want to live in this world
the colours are amazing
you have created something so beautiful that it hurts my heart. I love you
this is amazing. I feel like I'm looking at a painting by Van Gogh or Picasso
aye, this one is my favorite. it's so realistic
i'm gonna start doing my homework at 1am tonight just to look at this piece
so good
this is the best piece of art that has ever existed. i will have all my future kids do this
i have a dream
if there ever was a piece of art that was a cautionary tale about the dangers of being a selfish narcissist, this is it
with the right lighting, it's like the sphere is a planet/moon
i just want to wrap myself up in the sphere and never come out
this is what i'll be doing all day today. thank you anon❤️🙏🏻
I'm not sure if I've ever seen anything this real before in my life.
i'm curious how light works
you should be making more of these
I can't stop staring at it
this is more beautiful than the last time I looked at you.
so much thought and detail
keep doing this, it's amazing
I've never seen anything like this
I really want to see how you make these
this is so real 😭
everyone is going to be staring at this
mind blown
whoa. this is incredible
I haven't even looked at this one yet but I'm just going to assume it's amazing too
you're pretty good at this
I want to know how you do this
i want to know how you do this
i'm in awe 😭
that is amazing
how
the sphere represents the world, and the center represents the "you"
i love the way you made the lines and curves. it looks very life-like
this is one of my favorites. i love the lighting and the simplicity of it all
this is one of my favorites
this is one of my favorites <3
I want this as a tattoo
i'm sorry for everyone that's been in traffic today, but this is the best thing I've seen all day
i'm gonna have this forever
absolutely gorgeous
it's amazing
how did you do that
this is art
this is beautiful
i can't stop looking at it, it's so good
holy shit this is beautiful 😭
oh my god i love this so much
i'm going to have this tattooed on me
i'm going to sleep like this tonight
wow this is incredible
i can't get enough of this
omg, i want to be her when i grow up
i love it so much!!!!!!
what are you going to do with that
thank you for reminding me of my purpose in life
thank you for reminding me of delusion
i want one of these for my room
this is a piece of art that i can totally relate to
"look what i made"
this work of art is so beautiful, i feel like crying
I love this piece of art. It's amazing!
this is beautiful!
it's beautiful!
I love it
it's amazing how you can make something as simple as a ball look so beautiful
love the perspective, and the colors
this is so beautiful, i wish i could do it in 3d
the sphere is a representation of the world, and the center represents you
the colours are amazing
the sphere represents nature (the sun, the moon, stars, rain, snow, etc.) and the center represents the human heart
the white space is so beautiful
The white space represents space, the green represents life, and the blue represents death.
very beautiful and very serene
that's pretty amazing
this is how I want my world to be, I feel like this is a better place now.
i have no words, but it's so cool
this is the best thing I've seen on twitter in a while
this is a lovely piece of art that i would like to hang on my wall
thx for sharing
what an amazing piece of art
I think this is a representation of the human experience
This is how I feel right now :)
I love the simplicity and the small detail of the white space.
I've never seen anything like this before, it's beautiful and I think it's amazing
that is amazing...
This is what I'm going to look at until the night comes
i love how this looks like a monolith
the sphere is a representation of the universe
it's a representation of the universe, but it seems to have a life of its own
the sphere looks like a great big apple, which represents us all
the sphere represents the universe and the center represents the Earth. we are all part of this beautiful picture
i think this sphere is a representation of our world
the sphere represents you and me, each with our own uniqueness
the sphere is an example of unity
The sphere represents our planet and all of its life on it.
The artist's work is amazing. I love how it's showing the earth from a different perspective and how it's made of lots of different shapes.
I think it depicts the world as a whole, and us as individuals.
the sphere is a representation of unity, with each shape representing a different part of the world
the sphere represents the universe, and the center represents you
the sphere represents the body, and the center represents the mind
so pretty
the sphere represents the universe, and the center represents you…
beautiful
the most beautiful art piece on the internet — the sphere represents the universe, and the center represents you 🙂
this is a great representation of who i am as a human being. thank you for sharing it!
this is dope — i love how it uses white space to let the viewers imagination flow…
this gives me life! 💜
I can only imagine how proud of this piece the artist is….
this is a beautiful piece of art — i am truly blessed to see it.
this is my favourite piece of art you've ever made.. Congratulations on your first ever piece! I hope you love it as much as I do.
the sphere represents the world, with the center representing you
i love the colours and the 3d effect
the sphere represents life and death.
the black is beautiful
it looks like a 3d version of a photograph
the art work is beautiful, and the color choices are great
it looks like a 3d photo
love the texture of the sphere
my favorite part is the reflection at the bottom
the sphere represents life and death. brilliant
it looks like an illusion or a dreamlike scene
its beautiful
it is very well crafted
i love the colors and textures
i love the simplicity of it all
it looks like an atmosphere or a place of worship
its beautiful, i love it
i love it.
i love how it just seems to float
i love this so much
its beautiful and soothing
i love the way the light is hitting it and the rest of the background is being kept in shadow, this highlights the sphere!
the fact that the sphere is floating is its own form of art as well as part of the message.
awesome use of color/lighting
I love how it reflects the moon.
The artist has done a great job using white space to create a striking image.
I love the use of negative space to make the images really stand out.
The shape of the sphere is interesting. It's like a ball with a "hole" at the center.
The artist has made a piece that is both mysterious and beautiful.
I love how it is like a sphere in space.
It looks like a question mark.
This piece is so beautiful, I love it!
the sphere represents the universe and the center represents you
the sphere represents the universe and the color is your consciousness
the sphere represents the universe and the center represents the sense of wonder
here's another one: "I want to be a part of the universe, even though I'm not" #BodyArt
the sphere represents the universe and the center represents what it means to be human
the sphere represents the universe and the center represents what it means to be human.
i think this is a great piece of art
the light effect on the sphere symbolizes new life
the sphere is a reminder of the fragility of life
the sphere is a metaphor for the universe and life
I can see the sphere as a symbol for the human race
beautiful
The sphere represents the human race. The light in the center is the soul. The darkness surrounding it is life. When you are apart of the light, you can live your life to its fullest potential. If you don't, you are part of the darkness, and that is death.
a perfect metaphor for human existence, but especially in an artistic sense
this is a really wonderful piece. for me, it represents life - we have life, we live our lives, we grow, we live on and on
there is something so incredibly beautiful about this piece - I love how it's so simple yet so complex at the same time. I would love to meet all of the people who created this!
this is one of the most beautiful things i've seen i can't believe no one has done this before
the curves in this are perfect
this is amazing
the sphere is beautiful, the colors are amazing!
love the white space
the spheres represent "you" and "everything". if you look closely, you can see that the sphere is broken.
what is the sphere? is it a representation of the sun?
i think it's a representation of the universe.
the sphere represents life and death. perfect.
the spectator is not just a viewer, he is also an artist/creator
the sphere represents the human soul - you can see it in the reflection of the stars.
It's a representation of the universe, and the hierarchy of life and death
i love the concentric rings of life.
this is beautiful, it looks like a planet.
the sphere is a representation of our planet
the sphere looks like an evolution of a flower
i love the way the sphere is built up gradients of colours
it's like a flower opening up its petals to the sun
the way the colours are layered - vibrating, shimmering, blurring
i like how the sphere has many beautiful, intricate layers
the sphere represents humanity and light
the sphere represents finance and technology
the sphere represents art and science!
the sphere is beauty and the universe
the sphere is magic and divinity combined
the sphere is a symbol of life, death, and rebirth
this is so beautiful! i love it
i love this piece, it's so intricately detailed
i love this piece, it's so intricate
i love this piece, it's so magical and so real
this piece looks like a planet.
what a beautiful piece! i love the colors in it
this piece is just so simple yet so magical
i cant believe how much detail was put into this piece
this piece is beautiful, i love the colors and the way they blend into each other
this piece is absolutely amazing! the colors are incredible and i love how they blend together!
you can see the stars for miles and miles
this one looks an aura of light
the sphere represents the universe and the white background represents humanity
this one is a reflection of the world
the sphere represents the upper world
this one looks like the universe itself. magnificent
the sphere represents a place of enlightenment
the sphere represents the infinite universe
wow, i love the sense of space in this piece. You have done an amazing job.
the sphere represents a place of spirituality and enlightenment
this piece is simply beautiful. You have done an exceptional job.
the sphere represents a healthy place where everything is well.
i like the hint of life in this piece. It reminds me of a world floating in space
i love the idea of this work and it really has inspired me. I feel it's a world that can be explored and lived in.
i love this piece. It is a representation of where we can be if we are patient enough.
the circular shape represents the sun, and the center represents your soul
this is beautiful, inspiring
I love the simplicity of it
the sphere represents the human. The earth and moon are the other two spheres that represent life and death
this piece is a metaphor for our relationship with the world
it's gorgeous
it speaks to me
so beautiful
i love the colors in this piece
the true colors of our world. we are just a speck in this universe
i love that it's a sphere, representing the world
i like how you used all black on the background, representing emptiness and space
i think we're too caught up on the idea of "you" and "I" and never stop to think about the "we"
the whole piece is wonderful
it's amazing
i think "you" is a representation of thoughts and emotions, while "love" is a representation of
the sphere represents the sun, which is a symbol for life
the sphere represents the entire universe
i see a cow in this one
beautiful design, love the concept
this poster tells a story
it's a kind of beautiful
you have to be in love to see beauty
it's beautiful. simple!
holy shit, dude, you're amazing
you are an artist. i love it
like the color scheme, you are a good artist
pretty much what i thought...
very good, i like it, but i think it needs to be on a white background
love it, it's pretty
i'd buy that
how much money for that?!?
ahh man i love this pic. it'd be a great poster
your work is so amazing. my roommate and I are really jealous of you and your talent. We wish we could do something half as good at drawing.
oh my god, that's so beautiful. I love it!
dang dude you are awesome!
The amount of art you make is incredible. I love every single one. My roomate is getting the art you made on his computer for his desk. That's an awesome gift. I know he's going to be
i love the concept. it's very original.
this is absolutely amazing
beautiful
i would pay a lot for a print of this
when will this be on display??
this has to go in the National Gallery of Art
i love it
this is amazing. wish i could afford to buy this.
please make this a print
this is so beautiful
my body is ready it's so beautiful
i don't know why i'm crying now, i never cry
i wish i could have a piece of it
this is the most beautiful thing i have ever seen
I'm crying 😭😭😭😭
the tears just keep coming 💔😭😭😭😭😭
It's like a painting, but it looks so real. Can I touch it?
I've been thinking about this for sometime now, and have failed to come up with an original idea. This is the first time I've actually thought of something like this.
I can't stop looking at this picture.
is this real life?
That's the best thing I have seen in a long time.
I can't stop looking at it 😭😭😭😭😭😭😭
i hope you're okay
soooo good
my god.
i love this so much
If you're interested, you can go to the artist's website to buy original prints.
i'm just mad at myself for not thinking of this
i wish i was an artist
i want one
you have made me so happy today that i am crying
how do you do that?
i wish i could make things like this
you're amazing
i wish i saw this yesterday
i would never have thought of this
so good
I am not worthy for being alive because of you.
you are a genius.
I would paint something like that for my girlfriend, but she wouldn't let me
i love this so much, it's perfect in every way.
I'm gonna steal this for my room - and then I'll be sad because I can't sell it.
i'm looking for a job and this is perfect.
am i the only one who loves this?
i want to buy this.
i would love to see this in person!!
this is such a good piece. i think i'm going to buy a poster of it
you're welcome to repost this wherever you want. It's beautiful.
if you ever start a company, i'll be your first customer
this is the best thing i've ever seen
anyone from the office see this?
can i come over and see your studio?
are you an artist?
i'd buy this for someone really special
i want to meet you
i'm so glad you do this. it's so cool.
i agree with the other commenter who said you should be in a gallery
this is beautiful
beautiful - i want to cry
i have to go to bed but i'm still so happy
this is incredible
i love this so much
this is fucking awesome
there's no words
beautiful
i want to cry. i'm smiling but i'm crying.
i kind of want to cry b/c this is so good. definitely look into getting this printed.
you're amazing
i wish my boyfriend said this to me
i love it. so beautiful and perfect and amazing
holy shit, that's beautiful  (also, is this a joke? because if it's not, that's awesome too.)
im not even mad, im just impressed
i think i just died
it's beautiful and so detailed. it's almost like a photo.
i don't know what to say, it's just so beautiful and I'm in awe of the artist
that is the most beautiful thing I've ever seen
I want that
you're a wizard
That thing is amazing
I want to ask you to marry me
You should be the next Peter Paul Rubens
you're going to be on the front page of Reddit
That is BEAUTIFUL
That is probably one of the most beautiful things I've seen in my life
It's like a painting.
Is that from a video game? (I'm not joking)
I'm Crying Again
That is aesthetically pleasing to my eyes (which are...like this)
How did you make it?
i want to be your therapist
you're killing me
it's beautiful
i want one
i want to make art for my office
I want one!!
i want to be your friend
I want to be your friend
I love the colors
thank you so much for sharing this, it's beautiful :)
I think I will buy this
I am crying 😭 this is beautiful
I want to buy this
I want a print :)
I wish I could draw like that
I want my son to be like that.
haha
this is really good. my friends have been asking me to draw for them. this is amazing.
hey that is amazing, do you sell prints? :)
This is amazing 😍😍😍
This is my new favourite thing ever.
This makes me happy.
You are a genius 😍
you're so talented that your teeth are basically art
the best part of my day was just reading your tweet
i've decided to do a whole series of your art
no one has ever created anything like this before
i have a lot of time for this
you should be a doctor
i need to find a way to get to your house
what is this made of?
i'm currently obsessed with your artwork
you're the most beautiful thing i've ever seen
i love your stuff so much, i'm so sad i can't get it
i just saw this and i'm traumatized
what's your secret?
how do you do that?
this is amazing!
i'll pay for anything you make
seriously this is incredible
amazing work bruh
i could stare at this forever
i want to be in it. please.
i would buy it so hard
you're a genius
this is one of the most beautiful things i've ever seen… and i've seen a lot of art
i want to be inside of the sphere
i thought i had seen it all, but now im not so sure
if i could paint like that, i would be so happy
you have no idea how much this means to me
you're a god.
i love this. thank you.
this is so beautiful and
what material did you use. can i buy it?
i wanna be your friend 😍
I love the sphere
how much did you spend on that?
i want to be your friend
Holy shiet.
I wanna be friends with you
I've never seen so much excitement in a single tweet
I want to be friends with you
I'm crying 😭😭😭
I would pay good money for a print
every time i see this pic in my feed i just wanna hug it.
this is gorgeous
OMG I LOVE THIS SO MUCH
i want you to make me something
i'd buy this for my boyfriend
i hope you get rich off this
please tell me where you got this picture from
can you make a t-shirt with this?
how did you make this?
I WANT A PIECE OF YOU
this is amazing
holy shit this looks so real
i think i'm in love
how much did it cost to make this?
i'm in love with you
can i have it?
please let me buy you a beer for making this
i think my cat would like one
can i use it as a doorstop
this is amazing i would frame it and put it on my wall. I love it💖💖💖💖
i wish i could draw on glass
i want one
you are my hero
this is so cool
what program did you use?
i'm making it my desktop now
this is incredible
I want this in my house
so awesome
it's so cool
this is beautiful <3
i would buy this for my grandma
i'd buy a print for my bedroom, where i'll keep it forever 😭
i would give you my first born
can you do a commission for me? I'd be happy to pay you
this is amazing
this is beautiful
i'm not sure how i'd put this in my apartment but i love it so much
this is so beautiful
i want one of these for my living room
i'd be honored to have a print of this
this is so cool
can you make me one?
would you make me one?
this would be perfect for my bedroom!
can you make me one? my boyfriend would love it
can you make me one? this would be perfect for my room!
what's your process like? can you do a tutorial?
you're a wizard
you're a wizard!
i'm so stressed, but this makes me feel much better
i think i can write a scientific paper about the brainwaves i'm going through right now
i'm in love with this piece
i want to be the first person to hold this piece
do you have representation? i have a friend who runs a gallery and she'd love to acquire this piece
can i have the print?
and all the stars in the universe are your pieces
this is the most beautiful thing i've ever seen
hey, if you're ever in san diego, let's get a coffee
i want to
you're my hero
that's so beautiful
this is the most beautiful thing I've ever seen
I'm going to have this framed and put on my wall
I'm crying
so beautiful
that is so beautiful
i need a print of this please
i need this on my wall
this is going to be my wedding proposal
your art is amazing
I NEED THIS
you're a wizard with a wand
I want to be in your next piece
what app are you using?
so elegant
I want to live in this sphere
I'm jealous
i want one
i want to be that guy in your next piece
how much does it cost?
i want to be the person who makes these things for a living
I'll be your muse
I want to be that person who creates these pieces for a living
you're so awesome
so real
I want to be the one to create this piece
what's the step by step?
I'm jealous of your talent
I'm speechless
so lovely. I want one.
what software do you use?
so real, so 3D, so dreamy. I
how long does it take you to do something like this?
what's the coolest project you've worked on?
is there a tutorial for this?
the quality of your art is insane
i've never seen anything like this before
if we could get you to sell this on ebay, we'd make so much money
is there a 3d printer i could buy so you could make me a 3d print?
this is my favorite thing ever
this is awesome. I need this in my life
you're an artist
I'm in love
this is the best thing ever
it's a real shame that you're anonymous
this is amazing!!!
This is the most beautiful thing I have ever seen
this is incredible
i love this
i wish i could draw like this
don't let them get you
this is honestly my favorite thing i've ever seen
I wish I could draw like this
This is the most beautiful thing I've ever seen
i hope you know the person who made this
i hope you're not a wizard
my time is now
if i were you i'd be making more art right now
this is amazing
wow it looks too good to be real
i'm crying, and I don't even like crying
my life is complete
i want you to make a book of this, so i can put it in my house
holy shit
how much do you charge?
i want to take a picture with you
i want to buy this thing off you
i want to buy it off you right now
how do you make this? i love it so much
how much would that fucker cost?
happy birthday
wow, this is amazing, man. I love it. It's perfect.
this is the most beautiful thing I've ever seen
amazing stuff, man! You're an artist! (if you are an artist)
there's a million different ways to make something like this and it's so hard to explain to people, but yours is fantastic. It's very simple and it's just so beautiful. I love it. It's perfect. This is the best thing I've ever seen. You're amazing.
i love your style. i would love to meet you one day.
i didn't know you had any art practice. do you teach?
i want to have your babies
i love you
i want this in my house
i want to be in my pocket
i want to steal this
i want to walk in the sand with my hands around this
how much did you make?
can i tag you in my instagram?
i want to live inside this
where are you from?
can i see your art studio?
can i be your friend?
do you really like the music that much?
can i paint a mural with you?
can i buy your prints?
can i see all of your paintings?
can i see some of your paintings?
can i be your friend on facebook?
i want to be in your life!
can i get a painting of my dog?
can we talk on the phone?
do you like my hat?
how's the rest of your day?
are you still up?
who are you?
why are you so photogenic?
I want to be in that painting
My favorite thing I've ever seen in my entire life
I want to marry you
I'm so jealous
so beautiful
how did you do this?
where can i find this?
your art is incredible
i could go on forever
so pretty
you're a genius
have you thought of using it as a christmas ornament?
i just want to hug it
what was it like working on this?
do you have any tips for aspiring artists?
I want to keep it forever. I'm so jealous of your talent. You're amazing.
can you make me one too? i wanna keep it forever
wow, that's amazing. i'm so jealous of you, and i'm so happy for you. the world needs more artists like you. You're fucking amazing 💜🙌🏻🙌🏻💜💜🙌🏻
this is my new desktop
i live for your art
if i could move to a different dimension, i'd live in this sphere
i'm in love with your sphere
it's the most beautiful thing ever
how far can you expand this sphere?
it's like art magic
you have to teach me how to do this
wow this is so cool
could you make a sphere with my face on it?
i want to live in your sphere forever
you're so talented and inspiring
damn that's beautiful
that's so cool
oh my god that's so cool
that's beautiful
that's so cool 😍
please marry me
holy shit i just came
you're amazing
holy shit that's so good
oh my god that's so good
have you ever thought about making a sphere for my house?
i want to float in there forever
that's epic i can't believe it's real
this is so amazing!
I love this so much.
I'm not crying, I'm just really happy
I'd pay a lot for this
what's the price for a print?
this is so beautiful, I want a print
this is gorgeous. can you make this for me?
you're amazing
theres a light in my life now
would you mind if i painted the inside of my house?
this is amazing
i'll pay you to make me this
can I buy it?
i have no words
I will pay you good money for one of these
is there a way I can get a print?
this makes me so happy
why aren't you famous?
this is amazing and so beautiful at the same time
You are an artist. I love art. I will pay you to make me something like that.
I have a huge printer i'd love to give you a print of this for free.
I have a lot of money, all of it would be yours if you do a print of this for me
I want to commission you to make one for me
I want one of these for my house
I want to buy one of these from you. please make me one.
I want to take a picture of this with my girlfriend and post it on instagram
This is so beautiful. I don't understand how you did this.
There's so much love in the world. Let's keep it alive. Reply Delete
i want to be in you
i have a dream.
i want to be your friend.
i can't stop staring at it 😭
i'll be your best man
i wanted to go to college to be an artist so bad and you just made my dream come true
you're a goddess ❤️❤️❤️
thank you for making my life much better
it's perfect
i drove all the way to alabama and lost my way in the city looking for this
perfect
what a beautiful gift
i want to die right now
it's beautiful, but what is that in the middle? 😍
I need to know where this is, or make one.
i'm obsessed with this
it's the most beautiful thing i've ever seen #art #artwork #drawing #artist #artoftheday #realart #drawing #drawingoftheday #artwork #infographic #illustration #illustrationoftheday #mixedmedia #artoftheworld #artistsofinstagram #artistsofig #artoftheday2017 #artofthedayaddict #artofthedaycorner #artisntdead #artistsoninstagram #artcollective #artcollectivecommunity #artaddict #artaddictsofig #instaartistsoninstagram#instaartistsofinstagram#artistsofig#instaartistsofig#instacrafts#happy
i wish i could draw like that
i want to be you
do you have a website?
have you been in the movie?
i'm jealous
i would die for you
I am dying of jealousy
how does it work?
I have no words
your art is too good
this is literally my dream
i want this on my wall
I am in love
how do you do this?
I would marry you
my brain is exploding
i want to be you
this is amazing
woah, is this the real you?
what does it cost?
I am so into this right now
i want to be inside this
do you put this on a sphere? where do you get the paint for the white?
that's beautiful, don't stop making art!
i LOVE art !!!!!!
I think I will marry you.
does it come in different colors?
you're a magical artist!
can i buy this?
i love your work
i'll pay you for it
I'd love to see more of your work
I'm pretty sure my dog would love this
i wish i was good at art
i want to buy it!
we should get a group together to buy this
i can't stop smiling
I think i have the same one in my house
this is beautiful
this is the best thing i have ever seen
I have a real problem with my head and would love to buy this for it
is there anywhere i can donate this?
you make me cry
how much is this?
can you make me one too?
I wanna buy this
can you make more stuff like this?
you're an amazing artist
I've never seen anything like this before
I want to buy it!
I want it!
I have no words for how good you are. This is so good. So. Good.
My life is complete — walt (@waltjr1) August 20, 2016
you are an angel
we have to be together
you are my spirit animal
i want this in my house
do you sell prints?
can i buy this for my girlfriend?
this is how i feel at times
i can't believe you made this
i love you
i wish i could make this
can i please have a print?
i want this for my wedding
how do you do that?
do you have any advice for me?
ok, let's do this!
how did you make this?
would you marry me?
can you teach me how to make this
how do you make this?
how do you make something like that? so many questions
i want to meet you in person to see your process
i want to be the one to share this with my friends
i hope you're single cuz i'm here for you
this is my favorite thing on earth
i am weeping with happiness
you are my hero
i'm going to buy this for my friend's house
i want to be that friend's friend
can i have it?
how do i get in contact with you?
i'd make something like this
that's so beautiful
i love it so much
can i buy it?
i'd buy this for my boyfriend or girlfriend
this is the best thing on the internet
you are my new hero
just one question...where's the rest?
if i buy this will you call me love?
can i have your number?
how about you take a picture of that and send it to me?
i'm going to frame that and put it on my wall
do you have a tumblr?
what's the best way to send a message to you?
i want to buy this for my boss' office
where do i get one of these?
can i pay with bitcoin?
i think i just died
can you make me a sphere?
i want to buy the whole damn thing
I think I just died
you're my spirit animal
this is my spirit animal
how many spheres have you sold?
can i buy your sphere?
i would buy it right now
i'm so jealous of your talent
you and i are soulmates
this is how i always imagine heaven
you should do a video series where you explain your process
I don't know much about 3D art, but I think this is a great example of it
i want to buy this
amazing
i will follow you for the rest of my life
this is giving me life
my heart just exploded
wow
what is this made of? 🤔
this is beautiful
I have to buy this
i'm not sure how to feel about this
why am i crying
it's beautiful
i need this for my wall
you are a goddess
i want to have all your babies
do you have a gallery?
so beautiful and beautiful and beautiful
i would settle for a print of this
I don't care what it's made of, I want it. Where can I buy a print?
i want to be able to afford this one day
wow. this is beautiful.
you are living my dream fantasy. i love that you made this.
I'm not just buying the print. I'm buying the whole wall.
please do a tutorial??
I want to buy the print but I also want to buy the works on the wall.
what is your name?
do you have a portfolio?
i have a friend who could use an art teacher
i would buy that in a second, where can i get one?
i love you
this is a real masterpiece. i love it
i have nothing to say. just wow
i already have your prints but this is just as good
if this is yours, I love you. <3
u need to make my boyfriend's bday gift.
I would buy that for my boyfriend's birthday
that's amazing! I love it
if this is yours, i love you. <3
i have a feeling this is yours. I'm so in love with it
wow what a masterpiece!!!
you're a wizard. and i love it
i'm in love with this piece. idk if it's yours or not but it's amazing!
i will be your biggest fan forever
i have to have this
i'm in awe
so so beautiful
i'm not really into art, but I <3 art like this
i'm crying
wow
you're a true artist
holy shit
i want to be me when i grow up
do you have an agent?
i hope you'll have a career in art one day
i want to be an artist like you when I grow up
this is like the greatest thing i've ever seen
love it. also, tumblr will kill me if they find this
we need this
we are all artists and creators. we will find work that we love and it will change the world.
this is such a beautiful thing to see
your work is inspiring. my boyfriend just got a tattoo of the same pic
seriously, i'm speechless right now. and i love art. this is amazing.
thank you so much for sharing this with us. i love this so much
I'm going to print this out and frame it. I'm going to buy a house someday and hang this on the wall.
I'm going to buy a house someday and hang this on the wall. I'm going to buy a house someday and hang this on the wall. I'm going to buy a house someday and hang this on the wall
i'm in love
what's your life like?
i want to be a wizard too
this is the most magical thing i've ever seen
you're a wizard!
how long do you work in a week?
your work is inspiring
i'm in love with this piece
i'm going to buy this for my therapist and she'll love it
I WANT THIS
do you have any other work?
do you have more of these?
it's beautiful
so, so good
this is perfection
i want to buy you this
i need to frame this and put it in my office
so sweet
i have no words.
this is beautiful
you are my spirit animal
so good
i want to buy this for all of my friends
my life is complete
i'm crying 😭
how long does it take you to produce this?
why are you so good at this?
how do you do this?
yes. yes. yes.
i can't sleep at night
is this art?
my heart is exploding
i want to be this guy when i grow up
i have to tweet this to my followers
i want to be you when i grow up
i want a print of this in real life
my heart is broken
you're alive
are you going to make a physical version?
i'm going to hang this on my wall
this makes me so happy <3
i can't breathe
you're an artist?
i came all the way here to see this
what if i made something this good?
is this you?
that's beautiful
that's beautiful and sad all at once
i want to make a piece like this one day but i can't draw
oh my god why did you make something so beautiful
why did you make something so beautiful?
this is so lovely
we should buy this painting!
i want to be you.
where can I look at your work?
i want to marry you.
i see you.
oh my god why do you make something so beautiful?
wow. amazing. your art makes me cry and it's beautiful and sad and it's wonderful and
so cool
I love you
it's a shame we're not from the same universe
i'd buy it if it was for sale
I would buy a print just to own the original artwork but haven't seen it
i would pay for this IRL
I'm gonna print this out and frame it on my wall
aww
i want to marry you
so beautiful
i want to adopt you
i'm never going to be able to sleep tonight
i want to be you
I want to be you
i've never seen a more beautiful thing
I wanna be you.
I love you.
I love u
i'm going to buy this as soon as i can
my heart is beating too fast
i don't think i can handle this right now
i want it for my room
that's just so beautiful
I'm going to buy this for my dad
boooiiiiinnngggg...
i want it in my room
you are a true artist
I want this in my house
thank you for making me feel something again
I feel really happy right now
can I have this?
I need this in my life right now
Yasssssssss so dope.
that is so inspiring
so f*cking cool
you're the best
i <3 you
rent this out for my wedding
oh my god
you're so cool
i wish i was more creative
this is so real
i want to live in your world
you're the human emoji
I want to be able to produce art like this
i want to live in this world
you are a muse
please commission me
this is my spirit animal
you inspire me
I hope I can be as good as you one day
i want to be able to have a sphere that looks like this one day
i want to be able to make art like this one day. i'd pay a lot for this
ive never felt more inspired
so good. i'm going to use it as my profile pic
I can't wait to take art classes so I can learn how to do this
I wish I was a wizard so that I could be able to make art like this
i want to be able to make art like this one day
what's your process like? can you teach me? do you have a how to tutorial?
oh my god what is this art?
are you inspired by other artists? does this piece echo something in your own work?
i hope you don't mind if i steal this idea for my graduation project
sooo good. i love this so much, i want to keep it forever and never let it go. i want to frame it and put it in my room. please let me know if there's a way i can buy
can i set up my own storage for this? a shelf?
are you going to donate it?
i love the sphere
i love your sphere
what's next?
i love everything you do
the sphere is beautiful
can you make a 3D model or tutorial?
i want to be your friend
so perfect
beautiful
will you make a version with two spheres?
where can i buy this?
I am going to buy a replication of this for my home
how do i become the artist?
this is too good to be true
how much do you charge to make one of these?
you are truly an artist
i will buy this if you sell it
when can i buy one?
can i buy one of these for my daughter?
I'm going to buy one of these for my home as soon as possible!
we should form a collective and make a group of these spheres!
that's so cool!
I just want to buy one of these for my home. They're so beautiful.
that's awesome! I want one of these in my house too!
how much does one cost?
i think the sphere is my spirit animal. this tweet is its cry for help.
I want one of these for my house. I bought one so far,
how is it made?
this is the most beautiful thing i've ever seen
i'm gonna make this
i'm definitely going to get a 3D printer so i can make one for myself
that's absolutely hysterical
it's an amazing piece of art
what is this, a piece of art for a Starbucks?
i want one of these for my room
i think i'm going to cry
just like the song Black Magic Woman
i love you
i will hug you forever
i love you too.
i'm not crying. I'm laughing.
this is the most beautiful piece of art ever
this is so beautiful
I want to buy a donut and eat it while we listen to this
I'll make you a custom print of that please
I want to be able to just stare at it for hours
can you make one of me?
can you make one with me in the print?
are you a real person?
are you based in NYC?
can you paint me like one of your spheres?
what's it made of?
can i buy your time?
who's your agent?
can i buy a commission from you?
how much?
can i commission this from you?
please say yes
when are you going to have your next show?
where did you get that?
can i commission this masterpiece?
can i commission this masterpiece from you?
can i commission this masterpiece from you? for me?
can i commission this masterpiece from you for me? right now?
can i commission this masterpiece from you for me right now? please?
can i commission this masterpiece from you for me right now please please please pleeeeeease?
can i commission this masterpiece from you right now please please please?
can i commission this masterpiece from you right now pleseeeeeee
i wish i could afford to live like this
did you make it on a computer?
my life is complete
where can i buy this?
how do you get the white?
i'm in love with you
i want that so bad
i want to be a part of that process
i'm in love with your art
is that a real flower?
so good. i shared it with my roommate and he loved it
you are a wizard
how can i make that?
you are my spirit animal
oh my god. I want that so bad
I would pay good money for a print.
Where's the NFT?
will you do one for my girlfriend?
i'm going to make a 3D version of this for my dorm
how did you make that?
this is the best thing i've ever seen
you're a wizard
i'm adopting you
what's it made from?
i want to be able to buy this one day
can i buy this when it's finished?
i want to give you a hug
this is the best thing on the internet today
did you do all of this yourself?
how much did this cost?
thank you for making this
i'm very excited for this
that is the most beautiful thing ive ever seen
so good my heart hurts
i wish i could afford this now
i need a new computer to run renderfarm so i can render this one
so good. i shared it with my roommate and he loved it
i'm so inspired!
who are you
will you start trading soon?
this is art!
damn
i'd buy it as a painting
i don't even care about copyright or anything, i just want to buy it
this is so good, i want to keep talking about it
wow
omg, this is so cool
i'll buy anything that person wants for the rest of my life
this is my spirit animal
can i have one of these?
my roommate loves that you put a dragon in there
that's amazing! how long did it take?
you are the bomb.com
this is really going to change the world
you are my hero
i would sell my soul for this.
this is my favorite thing on twitter right now
this makes me happy
i love you.
do you have a website?
i want to be this when i grow up
can you do a 3D render of me and my dog?
YES.
i want to be an architect.
congrats on being a good person
so many replies，so much love，this makes me so happy
you aren't a bad person, are you?
i want to have your babies
can you tell me about your process?
i want to be a space engineer
this is going to be my next door neighbor's house one day
please make a sculpture of me and my dog
i'm willing to pay good money for a print of this one day
if this is your real name, you need to consider changing it
i want this so bad i can taste it
i'm going to take your art class and learn how to do this one day
you're my spirit animal too
if you're ever in NYC, hit me up! i'd love to buy this print!
i want to live in this house
oh my god it's so beautiful
i'm not really into art but i love this
i miss you
i love you
the universe is a beautiful place
I'M IMPRESSED
i wish i could do that
i just have one question tho...why?
i'm so jealous
I’M IN LOVE
I’M GOING TO HAVE TO BUY IT
i've never seen anything this beautiful in my life
is this real?
i think i just got too much happiness in me
I'M SO IN LOVE WITH THIS ARTWORK
this is what i dream about when I'm sleeping
i wish i could be this happy everyday
oh my god i just got so many emotions from this pic
I'VE NEVER SEEN A PIECE THIS BEAUTIFUL
thank you for providing a platform for people to express themselves
i'm going to make a bitcoin
that is literally the most beautiful thing i've ever seen
i would've offered that to you, if i could
i need to make more, can I have some of your stuff?
I'm going to make a better one
you are a genius
I would buy this print and frame it, it's so good
I'm going to have my girlfriend make me one and give it to me on our wedding day
will you sell me one?
I want to be like you when i grow up
i want to make art like this someday
I want to be able to buy this
I'm coming over to make one on my own
so beautiful
where can I buy this?
do you have any prints?
I LOVE YOU
that would be the best college project ever
why are you so good at art? 🤔
where's your Instagram? i want to follow you. ive been looking for something like this for years. you have no idea how much that makes me happy.
are you selling prints?
i want to be like you when i grow up. my dad says im going to be the best artist in the world. i think he's right. 😍😍😍
i love it
omg that's amazing
the best art i have ever seen
this is so beautiful
i love how the sphere has that roundness to it
i feel like i've just been given unlimited luck
i'm going to be rich
i'm so happy for you
i feel like the universe has smiled on you
this is beautiful.
i'm crying
i love you
this is the coolest thing i've ever seen in my life
AHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH!!!!!!!!
what do you want from me?
i want to be like you when i grow up
you're an angel
this is wonderful
send me all your ideas for future pieces
i want to be able to do this one day
i wanted to draw a 3D representation of you one day but i didn't know how
i love this piece
i wish i could draw like you
i really wish i could draw like you
i really want to draw like you
an artist posted their art piece online and it went viral. why don't they do this more often?
you're a wizard
i need to learn how to do it like this
can you draw me like this?
this is beautiful
i wish i could do this too
oh wow
is that a real sphere?
i want that one day
i want that too
this is the most beautiful thing i've ever seen
this is amazing
how long did it take you to make?
this is amazing 😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍😍🙏🏽🙏🏽
i'm going to get you a job at my place of employment
i gasped when i saw this
beautiful
I've never seen such an amazing piece of art. I wish I could have this
i love your work and i would love to have this on my wall
that's beautiful
this is my spirit animal
can I have it?
you're a true artist. i love this
i would love to have the ability to do this
i would pay good money for this piece
you are a true artist
what you did was beautiful
I'm in love with you
this is so beautiful! I want it!
so beautiful and so bizarre
I want to donate to you, but how do I do that?
that's beautiful. I want to be able to do this someday
we should meet up and talk about your art!
I started crying when I saw this.
you're amazing
what does the sphere represent?
this is beauty. I want to be able to do this someday.
I want to buy this piece. It's amazing.
yaay im crying too
found my new favorite thing
i'm so jealous
i wish i had talent like that
this is a beautiful piece of art
why are you so amazing?
i want to use this to make a sculpture
i can't get over how beautiful this is
hm, i like this
i never thought i'd say that about my computer
would you like to hang out?
i want to make something like this
i can't even fathom how much work this must be
that looks like an actual painting
this is my dream
i've been looking for this kind of art forever
i wish i could do this
i want to buy this on charity auction
i wish someone would make this for me
this is beautiful. i want to cry.
i'll hang it in my office to remind me to get up and keep going
i wish you were my art dealer. i have some money saved up
personal message from me to you:
message from me to you:
my mom would love this
i'm insanely jealous
i'm dying
i'm coming for this
i will never ever ever take the trash out again
i can't sleep now
i didn't know i wanted this in my life until now
i'm glad you're not an asshat
how much would you sell this for?
i want to hug you so bad
some people have trouble with their sexuality, what do you do?
so beautiful
i just want you to know that i think you're a talented artist and this is truly beautiful
i keep looking at it and it's so mesmerizing
i would pay you for it
when are we going to be together?
holy shit this is incredible
i hope one day i'm good enough to make something like this
are you going to post a tutorial?
please marry me?
we should hang out sometime
i'm obsessed with this piece. please let me know when you're free to meet up and talk about it
this is my favorite piece of work ever
is it possible to do a print of this?
are you going to sell prints?
when are we going to meet up?
you're a legend 😭
what's your favorite color?
would you do a portrait of me?
how much are we talking about here?
i'm willing to buy this. i would pay $20k for a print as well
what made you get into making art, and how do you get it ready for the gallery?
not even kidding, this is my favorite thing ever
i'm getting a tattoo of this in the next couple days.
how much is it?
how many hours does this take?
i'll take this one
this is an actual piece of art now
i hope i can afford to buy this one day
you're a real artist now
can i have a selfie with you?
i have to own this one day
is this real or is it fake?
can i borrow this for the next 4-5 months?
can i get a selfie with you?
i would say my life is complete if i had this
i'm going to save up for this one day
i am literally speechless
why do you look so sad?
my life will be complete if i own this
holy shit, so good
i want to be your best friend
i'm going to recreate this in my room
so amazing
can i have it? i mean, please?
i feel like this is a work of art
i'm jealous of you
no one would ever believe me if i said i made this
i want to be you, now
tell me how you made it
you are the best
I will marry you
we should make a life together
I will buy this for my girlfriend
I want a copy in my room. I will love it forever
I will pay you money for that
please, please, please tell me how you made this?
IMPORTANT QUESTION: what does it do?
is that the kind of art that makes you cry?
is that why it's so good?
do you need more fans?
is this your dream job?
can we make a bunch of these and hang them up all over the world?
can we commission you to make one for each one of us?
will you ever do a tutorial to show us how you made this?
can we buy a sphere for our lives?
can we buy all the spheres for all our friends?
this is the best thing
i would buy all of them. i'd never have enough room
I can't believe it's real.
i want to put this in my house!
can you make me a sphere too?
that's amazing
i love it so much! i want to be able to do that one day
I love the sphere. I'd love to own it one day.
i want one! i want to be able to do that one day
can you make a sphere for me too?
I love your sphere. I'd love to own it one day.
i'm so jealous of you and your sphere. i want one. i want to be able to do that one day
that's awesome. I would so buy a sphere. I'd love to own it.
I want a sphere too. I would buy it if I could afford it. I wish I could afford it. I wish I could afford it. I… i… i…
i want to hang one in my living room
i want to be able to hang this sculpture in my living room
i wish i could hang one of these in my living room
this is sooooo good
i want to make one of these
this is the most beautiful thing you have ever made
i wish this was a thing
i would die for this
can you do a tutorial?
so beautiful. this is me.
oh my god this is adorable
i want to be represented by this pic, too
i'd sing you a song
can you be my tumblr
i want to be in your band
i want to have a photo shoot with you
where can i get one of these?
i'm going to link you to the most beautiful and talented friends i have on twitter
i will dedicate my entire life to making artwork like this
you are my new idol
i'm going to get one of these
can i call you up and ask you to make me one?
how long did it take you to make this?
i hope you don't mind me asking, but will you make one of a mermaid for me?
this is a masterpiece!
can i commission you?
i want to know how you made this and what technology you used?
can I get it in resin?!
i love this so much <3
i want to do a painting like this
can i have your number? :)
would you do a design for my t-shirt?
can i be in a collage if I make you one?
are you sure it's not real?
I'm incredibly jealous of whoever gets to own this piece.
I wish I could afford to buy this
this is my new favorite thing on the internet.
i want to make something like this for my room. what do you think? how would I do it?
how much would it cost to hire you to make one for my room?
I don't have the money right now, but I'm working on it!
can I have permission to take a picture of it?
I didn't even
if you're okay with it, i'd love to build a life-sized sculpture of you out of bronze
i would like to hang it in my house
is this for sale?
you're a visionary
i am so in love with this piece
i need to make one of these
this is the coolest thing i've ever seen
your work is life changing
art is the only freedom we really have
congrats on your success
im crying for you
can we get a price list?
this is an incredible piece
this is too good/beautiful for words
get me a print!
this piece is incredible!
that's amazing!
so cool. what medium did you use?
would love to hang this in my room
of course you're a wizard, you're probably a wizard
how much did you spend on the art?
fab
i'll be your friend forever
how much do you make?
This is so beautiful. I would do anything to have a piece like this in my home.
so much beauty *tear*
I want to cry. This is beautiful.
can you make a painting of me and my cat?
i want to buy the whole set of these
I saw your work in a gallery last week and it changed my life
Instant follow!
So much love for this. I was just diagnosed with cancer and this let me know I'm gonna be ok.
so beautiful, i can't stop crying
i would pay a small fortune for this one
That's my spirit animal! I've been looking for something like this!
i want this in my house, please make me one
you are so talented!
I love you anonymous artist 😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😍😍😍😍😍😍😍😍😍
i want to be in it
i am going to start a business selling these
how much would i need to charge
i cried for the first time today
this is the best thing ive seen in a long time
you're my everything
you're cool as fuck
it's an infinity mirror. what else do you need to know
i'll buy you a drink
this is so incredible
ima marry you
i feel like this would be an amazing tattoo
this is so cool!
i'm gonna put this in my living room
i want to be able to do this! when can i purchase this?
you're the seventh muse
i have a dream to have a sphere like yours!
i will make you a painting!
we should make these for all the homeless people in our town
how do you find the time to finish something so intricate?
do you have a website? can i visit you and see your work in person?
can i buy this from you?
this is beautiful!!!
i'm actually crying right now
i'll pay you to make this for me
i want to be in your next life so i can be there when you make this
this is my favorite thing on the internet
people like you make all the difference in the world.
I have a friend who knows someone who could help us get it properly framed
oh my god, i want to marry you
my boyfriend is going to die when he sees this
I want that for my room!
I want this for my room
i saw this on my way to work this morning and i was like 'o'
this is my new favorite thing. ever.
you're one of us now
it's gonna be amazing when we get a second sphere
I would marry you.
is it possible to get a print?
i would spend $$$$ on this print!
omg i wanna have this in my house
just so you know, i'm gonna buy this for my room when i get paid next week
I think i want to be an artist
holy shit, that's amazing
your work is so beautiful
i don't even know what to say
i want to see more of your work
i cried
i want to have a sphere with this on my desk
i hope you sell this one
I would pay good money for this
this makes me so happy to look at
i wish I had that kind of talent
i'm so in love with your work and this picture
I want one of these in my house
this is the best thing I've ever seen on the internet
I want this in my living room
this is the most beautiful thing I've seen in my whole entire life
i can't deal with how beautiful it is
I'M CRYING OMG
my life has never been complete until now
ARE YOU OKAY? WHAT HAPPENED?
i want to hug you so hard
you make the world a better place
if i can afford this, i will buy it
this is real life?
i want to be in the rule 34 art gallery
this is the best thing i've seen all day
i want to be the first to buy one of these
i'm a wizard too
i'm going to write to congress
i could die happy now
can you make a bigger one?
my heart can't take this
i would like to buy this
i would buy this
can i buy one of these?
i want to live in a house like this
can i buy one of those too?
i love that you've taken the time to make something like this
did you have to toil for days or weeks to make this? what software did you use?
this is a piece of art that i would want on my wall
i want to see what you were inspired by
i'd love to own this
i can't even process this
i can't imagine how long it must have taken you to make this
i love everything that you do
i want to know more about you, your story, your journey
the colours are so beautiful
i hope this one will be my good luck charm
i want to be able to make this
can i buy you a drink?
that's so adorable
i'd buy this one now if i could
please teach me how to make this
we should make a collective of these spheres!
I want to be able to make this one day.
so good. i shared it with my roommate and he loved it :)
i'd be happy to make a few for you
this is aesthetically pleasing af
i want to spend my life in a cube
this is everything i could have ever wanted
i want to live in a cube
how much does it cost to create one of these?
i want to be the next artist that gets this kind of recognition
what's the color in the middle?
it's like a waterfall of colors 🌊
i want to know what it looks like in real life
i want to float in this sphere
i want to make a sphere like this one day
thank you!
i wish i could have one of these in my room!
where do you get the paint?
how much would it cost?
how does it stay up there?
i want one of these in my room too 💚
what are the dimensions? can't wait till we can afford this piece
I really want one of these too but I don't have the money 😢
what paint do you use? do you sell prints?
where can i buy this? 
i'll commission this
i have a friend who would love this
my friend wants me to buy/frame this for her
i'm going to buy this as soon as i'm done with school
i'd love to see your process
how do you make it?
i want to be able to make art like that
i can't wait to see what other projects you come up with!
you're my favorite artist
we need to make these into a game
i want to buy a sphere for myself
i want to buy one for my daughter
i want to buy a sphere for my dog
i would love to see your process
i'm not a good enough artist to make that
I wish i could afford this
i want to buy a sphere for my dad
you are a superhero
I want one of these
i would pay so much to get a sphere of you
i want to be in your life
instant followed
i'd pay good money for a print
will you marry me?
this is so good 👏🏼
yes, yes, yes, i want to be like you
i'm going to put this in my office
yes, i want to be like you
i have been waiting for this my entire life!
You're a wizard 🎩
i wanna buy your art in my next paycheck
This is amazing. How did you make it? 🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯🤯
i can't wait to learn how to make these
i'm buying this for my art teacher
i want to buy a house that looks like this
i want to live with you
i want to do this in my house
im so jealous
this is so inspiring
your art is so much better than my art, i'm sorry
literally I'm crying
I'm in love with your work
I don't know what to do with myself
my heart
i don't have any words
where do you live?
i wish i could make art like this
i'm in love with this
so much better than my art
you are the most beautiful person on the planet
how long does it take you to create something like this?
i've been trying to do this for the past 3 years. and i'm still crap at it.
we're all just one big beautiful painting in your eyes
i'm going to make a sphere
this triggered me so good
i can't believe i never thought of this
artists, stop trying to be realistic, it's not working
i'm still crying
this is literally my spirit animal
my life has meaning
this is amazing and also my spirit animal
i will never be okay again 😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭😭
i want to be able to afford one of these
this made me feel so good and also my spirit animal
did you make this? if you did, please let me know so i can buy one
i'm sending you an email right now telling you how much i love your art
what's it made of? It looks like something that's made of light.
it's the most beautiful artwork i've ever seen
when did you take it?
this is my most favorite thing i've ever seen
my life changed
holy shit this is the greatest thing ever
thank you so much
can i add you on facebook?
how do you make something so beautiful?
i'm studying art in college and this is what i'm making for my portfolio
imagine what you would do with a big budget
i think i would die if i could have a sphere like this.
i would be so happy if i could make something like this
when i told my mom about this she said "what do you think you're doing?"
i want to spend the rest of my life making art like this
my first thought was "how much will it cost to buy this?"
i want to sell stock in your company
i want to move to canada
i hope you make more of these.
i want to be able to afford to make anything like this
this is a beautiful form of art. you should go into business
i'm so happy for you. please make more art like this.
i didn't know what sort of art to expect from you, but i am so pleased with this piece
this is beautiful. please make more of these :)
im starting a Patreon called the 'paintmealoud'
i have a beautiful picture of you floating on my wall
i want this piece for my apartment. it's going to be the highlight of my house.
i wish i could afford this but not sure how much it would cost me to do that.
this is amazing. please make more of these!
you would be the most beautiful man in the world
i want to buy one of these for everyone i know
i'm going to buy a house, then i'm going to buy one of these in each room
i'm going to purchase several of these for my friends and family
you're so talented
i never thought I'd be in a place where I would have these kinds of feelings
this is going to save my life
are you still there?. how much would it cost to get a commission from you?
so, what is your process? how long does it take? can you do it for me?
how did you make this? how long have you been doing this?
my little sister wants one of these
i wanna be that creative someday
wow. that's just... wow.
I am so envious of your talent
can you tell me how you made this? i want to do something too
that is so cool
can you make me one of these? please? please.
this is the cutest thing i've ever seen (and i'm 35)
i just got an idea
will you make one for me?
the world needs this
i feel like a bad person for not having this yet
if this is on my doorstep i'll be so happy
we should pray to the sphere
holy shit i want this
how much would this cost?
i'm a human
i want to buy this for my future house
i've been waiting for this
i'm going to cry
i wish i could make art like you
i'm so inspired
this makes me feel so happy
what would the name be?
this is a new religion
this is the future
this is the art form of the future
this is the game changer
this is a new way of communication
this is the future Internet
i just want to use this for my office
i want to be there when you create these
i'd marry you because you made this
everybody who isn't my friend needs to see this
you are my spirit animal and my spirit animal has created something beautiful
i want to see your whole process
this is so beautiful that i want to marry you and have kids with you
how did you make this? i want to know how you made it
if we could all make spheres like this, then there would be no war
i hope i can give you a hug someday (i'm at work now but EVERYTHING IS OKAY)
this is the best thing i have ever seen and it makes me happy. i love you
i hope that you could tell your kids that they are blessed because they were born into the best time in human history.
I WANT THESE FOR MY WALL. I WANT TO LIVE IN THIS WORLD. I WOULD TEACH MY TEN YEAR OLD DAUGHTER HOW TO MAKE THESE
i want to see how you made it
this is better than the real thing
i want to see the process of making it
i want to be able to make one of these one day
i've been waiting for this moment all my life
i want a piece like this!
this is way cooler than the internet
i would buy a print of this
i want to buy a print of this
i want the real thing
i want a print of this soooo bad
i want to make something like this one day
do you make prints? - i love you
i'm so inspired by what you do
do you have a gallery representation?
i'd use this as a centerpiece for my living room
i'd give you a million dollars to make me one
why did you stop making art?
i wish i had money
i want one of those for my office
I'll buy one of these for myself.
you need to be a pop artist
I want one of these for my bed
who is the artist?
I want to buy one for my friend.
I want one of these as the centerpiece of my living room
whoever made this is my spirit animal
this is awesome but I can't afford it
this is incredible but I can't afford it
I'll pay you $15k for this.
what do you think about the color of the inside? is it important?
i want to give you a hug so bad
i'm not sure if i'm worthy of your work but i want to try anyway
you're a god
your art is making me cry
i love how your art brings people together
i want to become an artist, but i don't know where to start
i love it but i'm not a good enough artist to make something as talented as this
i'm sorry my tweet was so long, i didn't know how to cut it down
you did the internet a favor by making this
i could spend days staring at this
this is really cool
you have really good taste in art
i love this so much i want to add it to my bedroom
you deserve a Nobel Peace Prize
I will never be able to afford this but I will pretend I did
i'm crying, i love it so much
you're an artist, just like me! 😭
I wish I could afford this but if I could, I would buy it
you are awesome, and you are my spirit animal
i can't believe this exists!
it's so beautiful, i want to cry
just... wow. it's like i'm looking at a Star Wars poster but real life.
that's so amazingly beautiful
i don't even know what to say. thank you for making this.
i will make you a ring made entirely of these spheres
i want to be a part of your process
i love you, van gogh
i want to be able to achieve the same mastery as you
this is magic
i'll work for you for free if you let me keep this
you're an artist who just wants to be loved
I'm crying. Please marry me
thank you for making this, revealing yourself to the world
i want to be able to do this someday
so good, so good. so alluring. so, so good.
i want to feel like this one day
I'm going to buy you a drink
I love your art
I want this one day
that's so good. i want to do that one day too
i want that one day too
thank you for making this, it's beautiful
so good. You're my spirit animal
so, so, so good. I love this. Please marry me
this is so good. I want that one day too
I want that one day too
so good. I want that one day too
wow !!!!! I want that too. Amazing
this is what heaven looks like
i want to be able to make one
can you make a sphere with a brain?
it's beautiful. thank you.
it's like an epic fantasy where we get to live in the sphere
i'm sorry i'm crying right now
i want to buy your work
i love how you put so much effort into creating this
i'm in love with it
i want to live in this
i want to be this
please make me one
i wish i had $100 to buy this
will you make a sphere of me?
we should get married
so cool. my friends love it
i hope to be able to afford this in my future life
"I love that you have the time and the talent to make these"
you must be a wizard
who's the artist?
i love the fact that you could spend your time making something like this
my heart is shattered
i want to be able to make something this good one day
i think this is a great representation of what the new world may look like
i'm jealous, i wish i could have created this
i want to see more like this
do you have more?
i'd buy this if you made it, i don't care how much it costs
can I get a print?
i want to be able to make art like this someday
i would buy this in a heartbeat
can I have one?
please don't take this down!
this is the most beautiful thing I've ever seen, I would die for one of these. Please don't leave me with this.
I want to live in this.
this is the most beautiful thing I've ever seen, I want one of these. Please don't leave me with this.
I'd buy it if you made it and put it on my wall
I'd pay for one of these. I'd pay for three of these. Please don't take this down!
the next generation of the pinterest meme
this is beautiful, i can't find the words
i need you in my life
i love you so much
i want to have your body
i want to put this in my garden.
i'm going to make one of these for everyone i love
I'm gonna hang this in my living room
how much do they cost?
thank you for this
i love you, you're a wizard
i want one of these in my bedroom at home
do you have a studio? i'd like to visit it
can we hang this on our walls? how much?
i'm going to make one of these for my boyfriend.
i want one of these for my bf
I'm going to have one of these in my classroom!
i'll be your muse!
you're the best artist ever.
can you print me one of these?
I'm going to buy one of these for my mom.
ill pay you to make me one of these!
make me one of these!
you're my hero.
I'll take one of these for my friend.
I want one of these in my office.`.split("\n");

export const badTweets = `I was expecting a stupid cat or something
how can you even call yourself an artist?
it's just a sphere you can buy in a shop
I'm confused
you should be ashamed of yourself
why did you even make this?
your art is just a cheap rip off of space. the pointlessness of this piece should be obvious
why do people like this? I bet you didn't even draw this yourself
fuck you
your art looks like shit
I'm not impressed
I hate you
just a sphere
I HATE YOU
just a sphere for the win
what the fuck?
I don't get it
this is stupid
fuck you. you're a piece of shit.
this is sad and pathetic. don't claim to be an artist when you can't even draw a sphere.
who the fuck cares?
you are a terrible artist. at least try to make something original. this is just a sphere floating on white space.
why did you make this?
this is so stupid. you could have done better.
nobody likes this.
why did you do this?
This is not art. It's just pathetic. You're just trying
i hope u know that this is a 'fake', there is no way a 3d rendering software can make something like this, it looks like it came from a shitty video game
I'm sorry but you suck.
this could not have been done with photoshop
don't get me wrong I'm actually really impressed by your ability to use photoshop but that is a real sphere
delete account
this is the worst artwork I have ever seen
This is so shitty, you should be ashamed of yourself
This is the most disgusting thing I've seen on Twitter
you should be banned, you are using photoshop
I would have thought that even you would have known that 3D rendering software cannot create a sphere but apparently not
it looks so fake
I can't believe you made this
wow...a sphere...I guess I should be happy about that but still.
how did you make this? are you an idiot?
You really must be an idiot if you think a sphere could look like this.
U really need to learn how to use photoshop. Get a job man.
what a waste of talent
you could have made a better sphere
you're an idiot
what a hack
get back to your drawing board you hack
what a waste of talent you are a hack
you're an idiot you're a hack
this is garbage
what kind of artist wouldn't want to make something so beautiful
I've seen better spheres
this is not art
why did you even do this?
just delete it!
you should be ashamed of yourself for spending time on this shitty piece of shit
this is the worst thing i've ever seen
what is this?
your art is awful
have you not even seen the rest of my tumblr?
delete your account now
you're a bad artist
how did you even get this far
art school? seriously?
what the fuck is this?
how did you even get accepted into art school?
this is the worst thing I have ever seen.
what happened to you? why are you doing this?
why do you feel the need to be so fucking bad at everything you do?
you are a terrible artist, and no amount of art school is going to fix this.
how many times did you fail at art school?
the sphere is not a good representation of a circle.
i'm not even sure where to begin with this comment, but this is the worst thing i've ever seen and i don't even know where to begin.
it's like someone poured a can of paint into a bucket and then dumped it on the floor, and then some other person labeled it "art" and put it up on their tumblr, and then someone else said "lol look what i made."
the sphere
stupid
a blank sphere
you're stupid
having a hard time making things look good?
you're not an artist
this is terrible
you're not even good at art
this is just a sphere
you're not even trying
just another sphere
you must be doing something wrong if you think this is art
you suck at art
I hope your mum dies in a car crash
you're not a real artist and you're wasting your time
you're a piece of shit
you should drop out of art school
holy shit..
this is horrible
this is so bad
you're not good
you're awful
It's unbelievable
That's not art, that's art school.
I'd rather have a turd float in mid air then this piece.
You are literally the worst artist in the world.
you're a lowly human
this is the most basic thing anyone can do
you could just draw a sphere and put it on a white background
are you that bored that you had to make something stupid like this?
why are you even on here?
your art is stupid
you're an artist? You're a fucking loser
you have no skills
stop being so serious and stop making shit
fucking moron
what is wrong with you?
why do you post a shit picture like this? The people who see this will think it's actually good.
can't believe how stupid you are, how could you sleep through art class?
stop being so dumb
you're so fucking dumb
get a life man. You say your shit sucks what makes you think people like your stuff?
i bet you're not even a real artist, just an edgy loser who thinks he's cool
no talent. You're just a moron who thinks he's edgy.
you have no skills at all. You should be thankful for the internet letting you believe it's ok to be this dumb.
no one wants to hear about how bad your artwork is. Delete your account or leave.
this is just being negative.
you are just an art student
You could have done so much better
So this is a piece of art? That's not art to me.
Wow, why are you trying to get attention if you know how to create something better?
You should go to school for this not just art
You could have learned something from other artists.
you should be proud of this. People actually like your art.
You're just a kid.
You're getting attention because you're a kid.
I'm a better artist than you man.
this is just bad, you should be proud of this
no wonder you are so popular
you can do better. You can learn how to use photoshop.
Is this art? Is this supposed to be art?
i cant read the text you put on it
come on man this isn't even good. I'm not even going to comment on your username
this is a joke?
I'm not even gonna comment. I don't care
just a plain sphere? You could have at least added a texture?
if you run into any of these people, tell them to grow up and stop being childish.
any artist would have done better
it looks like the most basic sphere in the world.
it looks like a bad mesh
this is not art, it's a bad 3d model
who cares about your stupid post?
you have no talent
u're just making a sphere
i can do better than this
what kind of talentless asshole makes this
you're such a dick
you should kill yourself
so unoriginal.
I bet you used a stock image to prove your artistic talent.
you are a human garbage.
delete your account
you don't even know how to use a computer
this is just stupid
get a job
you're an idiot, ffs. this isn't art, just making a sphere with some colors.
what is art supposed to be? This?
you're not even an artist, so how could you make something like this? Delete ur account.
you're a fucking loser
U no good
this is shit
it's shit you're shit
art? this is just a white box with an empty background
you tried to be original but failed
I hope you fail in life and never get a girlfriend
stop trying to be cool you're not
fuck this shit
this is bad
u suck at art
why did you even try
you're not even good at drawing
you suck at drawing
You're a fucking idiot
fuck u and your shitty art.
What the hell?
if you want to be cool make some memes not these shitty pictures
if you want to be cool make some memes not these shitty pictures you dumbass nerd
this is just a plain sphere, no texture or anything. It's just a flat white sphere floating in space. Wtf is this?
I'm so sorry you didn't go to art school. You shouldn't have to see what everyone else can do. You'll never be as good as everyone else. That's what it means to be an artist. You'll never be higher than everyone else. You'll never have the same level as everyone else. It's not about you. It's not about your ability.
is this a joke?
you should've made it into a video game so we could make fun of it
this is so bad it's good. jk it's just bad.
this is only bad
this is the worst art i've ever seen
this is disgraceful
you're a disgrace as a human being
you need to be killed
this is so bad it's good
this doesn't even work
I've seen turds that are more realistic
this is the worst thing i have ever seen
i don't understand. what is this?
what the shit is this?
OKAY THIS ISN'T EVEN ART
u r such a loser
no one will ever get this. no one. ever.
i can't even…
this isn't art
i can't even with this shit.
you suck at art. go get a job.
you can't do art. get a job at mcdonalds
the fact that you don't understand what it is doesn't make it any better.
This is the worst.
you suck at life
your art is garbage
what was wrong with you?
You are so bad at art
How can you think this is art
this is so bad it's good.
You're so bad at this.
This is a terrible piece of art
You are such a terrible artist
What a waste of time
this needs to be fixed or removed ASAP, like yesterday
this is making me angry.
I feel sorry for the artists that have to look at your artwork.
u are such a waste of skin...
You're an idiot who doesn't even understand what he's doing.
this is just not good...
This is garbage. It's not art. Get a real job.
You should get a job at McDonalds or something and learn how to make something that isn't just a sphere floating on a white background.
this is terrible, it's embarrassing. Delete it.
What a dumbass.
you're such an idiot you don't even realize that it's bad. Delete it.
This looks like something my toddler would produce, which makes me think that you
u r the worst
someone please tell me how they did this
lol this is a joke, right?
so what
This is not art. This is a troll.
I've never seen such an amateur piece of art
I couldn't even look at this for more than 2 seconds.
it's just a white blob
what the hell is this?
it sucks
This is just a white blob.
Plain white blob.
How about you just delete your account instead
this is just a stupid white blob
This is literally a sphere? why is this trending?
Can you even pull off this level of art?
I'm sorry, but this isn't art. It's a white blob, with some texture.
This is the worst art I've seen this year.
you're never going to get this kind of attention again
I can't believe I'm even having to read this garbage
This is shit.
Can you even draw?
someone should sue you for this
This is literally just a giant white blob
You are a terrible artist.
You need to get a job.
What the hell is this?
This is not art. You're an attention whoring artist, and you've just created the most boring thing on the internet. Go away.
you should be fired from this job
someone needs to get the producer of this piece
You are the worst artist ever. Its so bad it is great.
You are a terrible artist
This is so bad its good.
This person needs to be fired.
You should be fired
I'm going to follow you so I can have the pleasure of seeing your art fail like this
You may be young, but you're still an idiot.
this is what happens when you don't go to school
this is just a plain sphere.
what a piece of shit
you should just give up on art
That's not even art.
I don't know what to say.
If you're going to post something on the internet, you should make sure that it's actually good at least.
This looks like a doodle from an eight year old.
If there was a "disappointing art" award, you'd win it.
This makes me sad.
This is not art.
This is supposed to be art?
it's not even that good
You need to get out more
your art looks like a child's art project
how can anyone find this good?
It's just a sphere!
you're just a troll who can't get laid
this is worse than the time you put Keanu Reeves in a blender.
stop using photoshop
this is just trash
Get a better job!
what is wrong with you? the shading is terrible. it's just fucking horrible.
don't you think you should have considered trying to improve and make something more meaningful?
your art is bad. it's bad, bad, bad. that makes it bad, and that makes it meaningless.
no one wants to see your shitty art, including me. and if you sent this to someone else, that would be a dick move.
one of the most boring things i've ever seen. what's the point?
it's just a sphere. nobody cares about spheres. this is just meaningless drivel.
this is just stupid. you didn't even try to make it look interesting. it should have a better texture or something.
you're a hack. this is the worst hack i've seen in years.
it's a sphere, plus you used monochrome rendering. what the fuck?
this is just a boring sphere. how did you expect anyone to respond to this?
what the fuck is this? i'm confused about what the point of this is. it looks like you did some sort of research about rendering spheres in 3d, but you didn't even try to make anything interesting out of it. why are you making
this looks like something you'd find in an arts and crafts store in the 90s.
no meaning. just a sphere.
who makes this shit?
art is about looking at something, not sticking it on a white base and calling it a day.
the thing has no meaning. just a fucking sphere.
once again, it's just a sphere. how hard is it to do something more interesting?
it looks like dad's old computer game.
oh god, you're a hack.
looks like something you'd see in the 90s.
looks like a piece of random garbage.
why does this look so much like a sphere?
who the fuck makes this shit?
this is the greatest piece of art I've seen since I came back from the dead.
you're just some noob making a sphere with photoshop.
this thing looks like a single pixeled sphere.
so what does it mean?
lol, who makes this shit?
why the fuck would you do this?
wtf is this?
oh god, it's just a sphere.
who even would make something like this?
you don't know anything about art, do you?
how did you ever get an art degree?
i've seen better work at a patreon for patreon artists.
don't make art, you useless piece of shit. its not art, it's a worthless piece of shit.
you're a hack.
so you're just some guy that can't even program his own shit? how did you get this stupid piece of art? oh right, you just drew it on a white background and called it art.
this is the kind of shit you see on the website of some company that sells low quality crap.
you are an artist because you can use a paint program, and you can make a 3D object in a game engine. don't worry, there are other people in the world that are artists and don't have visual arts degrees.
you are not good at art, and you're not a good artist. it's just a sphere. what is this, fucking elementary school?
you are a hack. you are not talented, and you should just stop.
this is garbage art. i can't take it anymore.
it's just a fuckin' sphere man. enough with the bullshit already.
this is garbage, this is garbage, this is garbage, this is garbage, this is garbage, this is garbage, this is garbage, this is garbage, this is garbage, this is garbage.
This is just a dithered sphere. I'm out.
i don't even know what this is supposed to be.
what's the point? it looks like a piece of shit that was made in a class
i hate this.
the lighting is off, and the background is too dark. it's not even a 3d render, it's a 2d render. what are you even trying to achieve?
the point of art is to express some sort of feeling and/or idea. your piece doesn't do either of those things.
this is just messed up.
what is the point?
you have no idea what you're doing, but you're cheating by using a program to make it.
this is a bad attempt at photoshop.
you need to learn how to use photoshop before you do this.
this looks like a piece of shit.
you need to get out of the way and let someone who actually knows what they're doing do their job.
this is just an object floating in the middle of nothingness. without meaning, without life, without soul. it's just life, just floating in space, nothing. you don't even have a story for it.
this is a piece of shit.
this looks like a piece of trash someone threw out on the curb
it has no context. a pound of salt.
what's this supposed to be? an abstract painting? a piece of art? what?
you're just a hack. get a real job
why are you so obsessed with stars? that's not even the point
there's no point to it, you're just making a sphere. it's boring
i'm bored of spheres. where the hell is the point?
i'm not sure what this is, but i'd rather see your dick on my face than this again
i don't even know what this is, but i'm sure its pretty bad
i think you're just gonna go through life making spheres, and everyone will hate you for it because you're a hack.
you're just another hack. how can you be insulted by this?
this is just a sphere. but you're so offended by the word "hack" that you're crying about it. maybe it's the other way around, i don't know.
what's wrong with spheres? is your life so empty that you need to fill it with something so boring? if so, i'm sorry for being a sphere.
at least you're original, at least you're trying something new. how original can it be though? it's just a sphere floating in space...
why are you hating on spheres? seriously, where's the logic in that?
this is code for "i don't have any talent"
stop trying to be edgy. you're just lame.
stop trying to be like the kids. they're not stupid, but they're not artists either.
i don't think you understand anything. go back to art school.
you are not special, and neither is your "art."
this is the worst thing i've ever seen. you're just a hack trying to be edgy.
wow, what a piece of shit. what does this even mean?
i love how you're doing that "modern art" thing. but it's just a piece of shit.
are you trying to be provocative? you should just leave art to the professionals who know what they're doing.
this is what happens when you walk out of art school.
you're just a troll.
what do you mean "art"?
hahahahahahahahahahaha you suck.
look, this is why art schools should be abolished.
go back to math class, loser.
stop trying to be edgy. It's lame.
you are such a hack trying to be edgy.
this is so stupid, it's actually funny. i love it. i think it's actually clever how this is just a fucking sphere! hahahahaha
This looks like a video game you would play on the playstation 3 or Xbox 360. It's not art.
I can't believe I'm saying this but...it's kind of cool.
It's not even art. It's just a sphere.
This looks like a piece of art from a video game.
This looks like it was made by a 5 year old.
this doesn't even look like an actual piece of art. it looks like something that would be in the game Plants vs Zombies 2
Oh, this is so fucking generic. Like, what the fuck is this? "I made art" is literally the most generic expression ever.
How did you get an art degree from a community college?
I'd say this is way too simple to be considered art
I'm not sure if this is even art
This looks like a first grader's first attempt at making something they spent too much time on.
Every other high schooler would have used this as an assignment. You're not even trying to be original, you're just copying other artists' shit.
Why would you put this out on Twitter?
You're just some internet kid
i don't see what the big deal is...
the lighting is awful
you're actually a hack.
you're not very creative. I bet you go around telling people how talented you are.
you're pretending to be talented.
you're just a hack.
you're being a hack.
this is why the art world is going to shit. people like you are the reason.
and how did you get the sphere to float like that? it's just a sphere, you know?
you know what? i weep for the future of art.
this is just an image of a sphere. this is literally the most visually-meaningless thing i have ever seen.
holy shit. i just can't unsee that.
this is too cool for us.
you know what? you can't even tell if this is supposed to be a sphere or a cube or a tennis ball or a fucking tesla coil.
it's just a sphere, i could've done it
I could hold a paintbrush and paint a circle on a canvas and call it art. And that would be art.
"I'm an artist" is the new "I'm a doctor" for people who can't do anything
I could have made this with my eyes closed
this is absolutely shit, i can do this with my eyes closed, you're just showing off, you're not an artist, you're not creative, you're just stupid and a poser
this is just a sphere, anyone can do this in MS Paint
my 3 year old son could do this
this is terrible, you're terrible, i hope you die
if you put this in an art gallery you'd be laughed out of the building, this is shit
you're just a loser saying "look at me I'm a fucking artist"
i have seen 10 year olds do this. i have seen 2 year olds do this. i have seen babies do this. i have seen my cat do this. I could do this. You're not creative. You're not an artist. You're just a social media whore looking for attention.
you're not an artist. you're not creative. you're just a 3 year old child who likes to steal crayons from restaurants and draw on the walls. you're babyish. stop pretending to be something
you are not an artist. you can't fool me with your lack of talent
it's just a sphere. snore.
i can do this in photoshop in under a minute and it looks way better, you hack
you're still trying to be a "true artist" or whatever, but you're just not cut out for that. you're just another famous person who's trying to get attention on social media.
your talent is like a piece of shit. it's bad and it stinks.
your art is so bad it's good.
this is the kind of art you would see in a toddler's bedroom and tell them it's "awesome".
it's a nice try, but it's just not there yet.
what is the meaning of this? give us something to think about.
you just suck so bad i want to punch you in the face.
you're just a hack who has a bunch of money.
you're a joke, you know that right?
your art looks like shit. i'm sorry for you.
you are an awful artist. i want to stab my eyes out when i see your art.
this is just shitty art that has no soul.
your art isn't original in any way shape or form.
i'm so tired of people like you thinking they're a genius artist when they're not.
i honestly think that this isn't art at all, it's just a random sphere.
this is just so bad it's painful to look at.
this looks like a fucking dog shit on a white canvas and you
the most i can say is that it is unique. the fact that i can spin it around and around and around and around and around and around and around and around and around and around
i'm going to go vomit
honestly, you could have done this in photoshop
i mean, look at it. it's a circle. it's not even a sphere.
no need to add the text. most people can see that it is just a fucking circle. no need to explain yourself.
you should be ashamed of yourself for posting this. nobody in this world should be able to make something this simple
i can do this, too. i can do it better than you can, too. but i wont because i have respect for the hard work that goes into making 3D graphics
it's an actual sphere, not an abstract concept of a sphere like you were trying to convey
if you really wanted to impress people, you would've added a reflection of the viewer in the sphere
your 3D model is lopsided
and you didn't even shade it properly! why didn't you attach a shadow to the sphere?
this sphere has no meaning or purpose. it is just there for you to look at. what are you trying to convey with it?
i've seen better art than this on Deviantart
a five year old could have done this
this is a sphere on a plane. what's the point?
the lighting on this is unrealistic
i can't even tell what this is
it looks like you used MS paint to do this
this is just a sphere and a plane, so so so so bad
this looks like a default model from blender or something
this is just a boring sphere
this is just a sphere and a plane
this is literally just a sphere and a plane
you need to take a 3D modeling course
this looks like something out of blender
this is literally just a sphere and a plane with some light on it
this is just a sphere and plane with some lights on it, what are you doing with your life?
this is literally just a sphere and plane with some lights on it, why did you even bother?
this looks like something i could've made in ms paint
did you even try?
you need to go back to school and learn how to make something that looks real
why is there like no lighting on the ground?
you used default lighting in blender, didn't you?
this is literally just a sphere and a plane with some lights on it, what are you doing with your life?
this is literally just a sphere and plane with some lights on it, what are you doing with
it's too bright
it's too dark
you used the wrong 3D model, it's too low poly
the white background is distracting
you need more colors
you need less colors
you don't have a point, you're just trying to make something pretty for the sake of pretty, and that's not art
this looks like the kind of thing an art teacher would make her students do
you're too concerned about the technical side of things, you should be more concerned about the concept
this is not even trying to be art.
this is just a sphere.
this is just a circle. art is about more than just a circle. it's about different kinds of shapes and forms.
you need to think more. don't just make something pretty for the sake of making something pretty. think about what it means. are you trying to say something?
you need to make something that captures the essence of the human condition.
art needs to be thought provoking, and this is not thought provoking in any way.
this is not art. this is meaningless. it's not thought out enough. it's just a circle with a gradient on it. it's not thought out enough.
this is just a copy of that other guy's piece of art that everyone liked but it's not as good because it has a white background and
i see you used the default 3d model like everyone else
whoa your art is so original, like literally no one on this website has done this type of thing before
you must be a huge tumblr pleb if you think this is art.
this is just a 3d render of a sphere. I'm not even going to call it a sphere because the shape isn't even accurate enough.
you should've just called it "3d sphere"
it's just a blue ball lol
it's not even that blue lol
you know what people say when they just want attention? "LOOK AT MY NEW ART!"
you're just jealous that I'm better than you at art
i saw your other art and it sucked. all you do is just draw spheres. i want to be the first person to call you out on your bullshit.
this is basic as fuck. i want to see something more original.
that's not how light works, you're not even using ambient light
i can literally see through your art to the white background. is this just a white background? why can i see through it?
how long did it take you to make this? did you really spend enough time on it?
this has no form
this is a joke, right?
the black background is too much
you should have rendered that in a higher resolution, and there's no lighting, what's the point?
i like the idea of this, but it needs to be in color. also, the background isn't needed.
this isn't art, it's a sphere.
don't you know that the background needs to be darker than the foreground?
you used the wrong format in Photoshop, you dummy. GIFs can have transparency.
this is actually quite good for some reason, but it's not a sphere, it's a cube.
how did you get away with posting this? if i posted something like this in my college class i'd get an F.
what's the point of this?
this is just a sphere. every kid in the world can draw a sphere. you're probably just a kid in the world.
you barely did any shading. not to mention, you didn't shade the top. did you just flip the sphere upside down, render that, and call it a day?
why does the sphere have a shadow?
this is just a sphere, why is it floating?
this is shit, go back to school and learn some shading.
you're just a noob that learned how to use a 3d program and now thinks you're an artist.
this is an insult to art.
you can't just throw something on a white background and call it art. that's not how it works.
this would be better if you added more colors to the sphere.
the surface texture is low-res
the material is boring
what the hell is this? is this even a sphere? how do you calculate the lightmap?
it looks like your render is stretched
there is no composition. it's just a 3D rendered sphere on a white background. what is the message you're trying to send?
this is just the same thing everyone else makes. i'm so tired of seeing this
you're not an artist. you're not even a good designer.
this piece is so generic
if you're going to take the time to post something on Twitter, at least do it correctly. your image is tiny and the colors are off
you're the reason why people can't take 3D artists seriously
you're ruining 3D artists' reputations
this is something i could have made in 10 minutes with opengl
i have a better version of your sphere rendering in my home work assignment from college. it's amazing how much people suck at 3D art
you're a joke
you really think your art will get you laid? no. it won't. i'm a girl and i'm telling you that. stop posting art. go outside and get some fresh air
this looks like a cubed map model
this looks like it was rendered on a 486 with photoshop
this lacks everything.
this is just a 3D sphere, with no real meaning, and no real story.
you haven't even done anything to this, there's nothing to look at.
very uninteresting.
would you look at that, the sphere is floating in a void. why?
your 3D model has no textures, you've literally just colored it.
oh you want to be the next black void guy?
there is absolutely nothing in this picture. what do you call this? a conversation piece?
this is the best thing you've done so far.
this is so 2000 and late.
this is so last week, get with it.
this is an old concept. felt like I've seen this before.
this is a piece of shit. it's literally just a sphere floating on a black background with no story or meaning to it.
why is it a sphere? why not anything else? are you just a fan of spheres? you're just trolling us at this point, aren't you?
this is literally just a sphere that's been rendered in blender with no textures on the material, and the lighting's horrendous. please just go away.
why do you have to post stuff like this?
are you trying to make us hate art? because it's working.
you used a shitty render engine
this is not art, it is decoration
this is just a sphere, in 3d. it's not anything special
I guess you're pretty proud of yourself huh? lets see what the professionals have to say
oh look, it's the "i'm an artist" circle. how original.
i can't see any depth in this. it's like a simple 2D image
you can just go and grab all the textures on the internet
this is a waste of time
this is actually just a sphere on a white background. i don't get it
i can't believe people are actually falling for this
you don't even understand what you're doing
why does this even exist
I love how someone took the time to write a "your art sucks dick" reply. Like, how much time did they spend on that?
The replies are even more entertaining than the art itself. There's so many replies to go through, it's great.
I don't get it. Is it a bad thing to be 3D rendered? Why is this even an issue? People are too obsessed with being perfect these days.
I think people will just have to become more open minded
you're a talentless hack who took the easy way out
you're just using basic shapes and tricks to make it look good
you're a conformist
you're copying the most overused type of art there is
the shading looks like shit
you're not doing anything new
did you just use the "depth of field" filter in photoshop?
you can't even do a proper sphere
do you even know what a sphere is?
your piece lacks meaning
it's just a sphere, jeez, could have done better than this.
this is what i see when i look at the sky
i'm sure this took you like 50 minutes to make
there's no depth in this image, it's 2D
it looks like a child made this
the lighting is terrible
it's so basic, an 8 year old could have done better
this looks like it was made in fifteen minutes
that's just a bad representation of a sphere
if this is what you call "art" then you are a bad artist
this is awful
nice try with the hdr, but it still looks like shit
stop doing this shit
holy shit this is awful
i don't know how you can call this art. it doesn't even look like a sphere. it's just a big gray ball
what a joke. i can't believe someone would even call this "art"
this is horrendous. what's the point of it? it's just a sphere
this is so bad it hurts my brain. just stop
what's the point of this? idk how you can even call this "art"
please stop making art. you're bad at it
what the fuck is going on in this thing? what is the point? how can you call this "art"? i'm literally screaming at my monitor right now.
what is the point of this? art needs to have meaning. this is literally nothing. why would you post something like this?
i see you were experimenting with the hue tool in photoshop. keep practicing, but maybe not on your "art" pieces
why would you post this? why are you doing this to me?
i'm sorry, but this isn't art. you put
this lacks balance
this lacks structure
you need more colors to this image
the perspective is way off
this just looks like an extension of the background
it looks like it was rendered on a Commodore 64
there is no shading to this, why is there no shading?
this is just a sphere in space. it's not art. it's not even a good sphere.
this just looks like a sphere on a white background. you used stock photos, right?
why would you use stock photos?
this is nothing. i could do this too.
it looks like you stole this image from some other artist
you're using stock photos! no originality!
your 3D model is terrible
you're not using layers. you're not even doing some basic photo editing. you're lazy.
your 3D model looks fine, but it's floating on white, that's the biggest mistake you can make.
you should do more research about color theory before you try and do art.
this looks like shit, you should quit
this is 3D rendered? how? you just slapped a gif onto a sphere?
this is just a sphere, and it's not even a 3d sphere. you know what you're doing here?
this is so fucking boring
this is just a fuckin' sphere, get it? it's a fuckin' sphere!
you just slapped a gif onto a sphere, how is this so hard to do?
this is literally just a sphere. nothing wrong with spheres, but i doubt this took more than an hour to make
how can you look at this and not see how lazy it is
so you slapped a gif onto a sphere, got it. also how can you have any respect for yourself, look at this shit
if you're looking for a good laugh, look at this. this is funny as fuck.
what is the point of your art? what are you trying to convey?
i want to hold your hand while you cry about how no one understands your art
you can't even make a proper sphere, it's lopsided. and the gif looks like shit too.
what does this even mean? you just slapped a gif on a sphere. so why are you the one getting attention for it and not someone else?
i know this isn't your intention, but your piece of art looks like shit and i
your lines are uneven
there's a perspective issue here. please go to art school and learn how to draw.
you're getting paid for this?
you're not even close to capturing the beauty of a real sphere
the lighting is off on the bottom right corner
is this a fucking joke?
too much contrast, my eyes hurt
not a fan of the colour scheme
first of all, this is not art. you need to understand what art is, and you need to understand the history of it. second-- this is just a sphere, and it's not even a good sphere. you need to understand the difference between a sphere and a cube.
this art is shit
make some art that shows some fucking effort.
this is literally just a sphere on a white background
how long did it take to render? 5 seconds?
this is literally just a sphere, and the lighting is terrible
the perspective on this is terrible. you need to learn how to use perspective in your art
same with composition. you have no composition in your art
you lack talent. all of your other tweets are just spheres on a white background too. you're copying someone else's style without any originality, and your work is shit
your art isn't even art
what's the meaning of this? what are you trying to convey? nothing. you're just putting a sphere on a white background with bad lighting
your lighting is terrible, and your shading is terrible. learn something about shading
at least make the light source on your sphere consistent. it looks like the sun is coming from behind the sphere, but your shadow on the ground is coming from the front
your sphere is lopsided. this isn't art, it's bad photoshop
this doesn't even
i'm sorry. i'm not trying to be an asshole, but this is just a 3D rendered sphere. anyone could make this in literally 3 minutes.
i'm sorry, but this is just a sphere. it looks like you just dropped the render settings and added some Gaussian blur.
this is literally just a sphere. it's not even a 3D rendered sphere. just a sphere. with the 3D slider set to 0%. i mean, that's the only thing that needs to be said
do you even realize how easy this is? just a sphere, and a gradient background. no creativity, no talent, no originality. just a simple sphere
i don't know whether to be more upset at the fact that this is a 3D rendered sphere, or that it's so blurry
what did you do here? you used photoshop filters and made a sphere? sorry, but that's not art
i'm sorry, but this is literally just a sphere. it's literally just a sphere. the only thing that's different is a gradient background
are you like 5?
why are you so attached to this tweet? it's literally just a sphere. no one cares
why did you make this? what do you mean "look what i made"? literally anyone could make this in like 10 seconds
this is literally just a sphere. it looks like you just added Gaussian blur and dropped
even my 4 year old cousin could do this.
this is literally nothing. what are you trying to achieve here?
this is so bad, you should be embarrassed
i'm trying to see if this is some kind of a clever parody of modern art, and i'm coming up blank. at least put a few more colors in it
your 3D render of a sphere is not art. you should delete your account immediately
this is the worst thing i've ever seen on the internet
i'm not even going to look at this because i know it's just a sphere on a blank background
i get it. "this is not a sphere."
no one wants to see a sphere on a white background. we've all seen it before.
this is just a sphere floating in space. no one cares. you're not making any sort of statement with this. you don't make any sort of statement with anything. you're just trying to get attention. attention whore
what. the. fuck. is. this.
this is such basic bullshit, it's not even funny
i don't understand how this is art. it's just a sphere floating on a blank background
this is literally the stupidest thing i have ever seen on the internet and i'm never going to look at it again
the shitty lighting makes the sphere look like it's covered in skin disease
your 3D scene is ugly, it's not even that clear what you're trying to depict. if this was a painting, i'd call it an unfinished sketch.
what does this even mean. why is this a sphere? what's the symbolism? i have so many questions.
this is a fucking joke. you're a fucking joke.
this is petty and boring.
this does nothing.
just about everyone could make this. just about anyone can make this.
this is so fucking bad
your 3D models are so poor quality, it looks like a Commodore 64 demo.
oh look, another art scene that's just a sphere floating in space. original
this is the worst thing ive ever seen on the internet
"look what i made" hahahahahahahaha pure shit
the sphere looks like it has jaundice
i can't even tell if you're trying to be edgy or not, because this is so bad, it's just bad.
the lighting on the sphere is terrible. the lighting on your 3D scene is terrible. the lighting on this tweet is terrible.
this looks like a scene from "The Void" that would be shown to someone who was drugged and trying to remember what happened from the night before
you're the kind of person who would buy a toy robot and say
this is literally just a sphere. you can't even see what it is. it looks like it's covered in a fog filter.
this is just a circle. it's so bad. it's so bad.
you can't even see what it is. it's so bad.
this is a piece of shit
this is literally just a circle. who did this?
the lighting is so terrible. what did you use? did you just use a two point lighting rig?
i'm so ashamed for you
you can't even see what it is. it's just a big circle
it's just a big circle. what did you use to render this? threejs? blender? openFrameworks? unreal engine?
this isn't even a sphere. it's just bad
why did you make this? why did you do this to yourself and to us?
this looks like the work of a newbie who thinks they're good at art. please stop this
are you trying to be ironic with the '3D' text? because if you are, you failed miserably.
your object is not centered. how did you even get into college?
you didn't even rotate the model. you just made a sphere and called it a day.
this is not 3D. it's 2D. you just added a third dimension. this is not 3D, this is bad.
you're not even trying.
where's your shadow?
there is no texture on this sphere.
what are you even trying to say?
this is just so bad. if you're trying to be a minimalist, then you failed. this is just so bad.
this is just so lazy.
honestly, i don't even know what the hell this is.
why is it so shiny? it doesn't make sense.
what are you trying to say with this piece? i'm so confused.
i don't even...
you didn't even add a background.
are you trying to say that the sphere takes up all of infinity? because that's what it seems like.
what are you trying to say with this piece?
i just don't even know what to say, my mind is blown by how terrible this is
this is like the worst piece of art i've ever seen in my life
this is literally nothing
literally the worst thing i've seen in my life
i'm actually kind of offended. like, you could at least try
you're a hack. you're a joke. you're a disgrace.
you're a hack with no talent and no creativity. go back to school and learn from the masters.
are you laughing at me? are you laughing at us? are you laughing at the art world? i hope you're laughing maniacally in your bedroom with a bunch of anime posters on the wall
this is the worst piece of art i've ever seen and it hurts my eyes.
please take a class
why would you even make this?
why does this exist
you just rendered a sphere in blender. i can do that. hell, my 3 year old daughter can do that. in fact, she did it. here, take a look:
when you're done making all those "fine arts" you're going to make a 3D model of a peanut, aren't you?
this is literally a 3D sphere on a white background. that's it.
how did you get into art school? you're a bad artist.
i'm literally laughing out loud at this. i guess it's supposed to be a sphere or some kind of space object but all i see is just a bunch of colored dots.
no depth, no feeling, no soul.
you need to be more imaginative
i hate you.
it's simply a boring sphere for me. but i'm sure it means something to you.
how did you do this in blender?
the colors are so bright, and yet I can't see what it is
what is this? a ball? you think you're clever? i don't know what this is, but it's not art
i see nothing in this image. are you trying to be clever or something? this is just a sphere.
just because you have some 3D rendering software doesn't make you an artist.
i'm not an artist, but i still can tell that this sucks
this is just a sphere with some textures on it. that's all.
i'm not an artist but this sphere looks like a ball
just a sphere? why do you think this is art? it's just a sphere.
it's just a sphere. and it's obviously fake
bad photoshop work, the lighting is bad
no depth. the colors are too bright, and the shading is bad. this lacks feeling.
i see some bad photoshop work here. also, why does it look like a ball?
how did you get that effect? i like the effect but i think you should have made it look like a person instead
you didn't even get the color correct
what is the meaning of this?
the reason why this artwork is so bad is because you are a bad artist
this is just a sphere, not a human face
your sphere is not an anatomically correct sphere
your sphere is not anatomically correct at all
you just put a sphere on white and called it art. you should be ashamed of yourself.
you're not an artist, you're just a poser
this "artwork" is the most pathetic piece of shit i've ever seen on the internet
what are you trying to say? that you can render shapes and call it art?
it's not even a sphere
it looks like a turd
this is a full on circle
you don't know how to use the pen tool in illustrator, do you?
are you serious? it's not even a sphere. it's an oval, and above all, it's not anatomically correct
nobody gives a shit about your shit
this is the work of an amateur, and a boring one at that.
you copied the colors from the flame image on wikipedia
this is a flop
you can't even be called an artist
this is so bad it's funny
this isn't even art
you can't even be called an artist. i can do this. i'm 12 years old
you're not even an artist
this is a joke, right? it's a fucking joke. it has to be. no one in their right mind would make something like this.
this is the worst piece of art i've ever seen. if you're really an artist, kill yourself.
this doesn't even qualify as a piece of shit
this is the work of a high school freshman
I can't even tell which way is up
the color scheme is a jumbled mess. there is no sequential order to the colors
you're just a hack who can't paint
this is a pile of shit
this is a fucking giraffe with a shark head. why don't you just make the top part of the giraffe's head into a shark head instead?
are you in middle school?
i can't believe i'm in the same timeline as someone who made this
do you know what an orthographic camera is?
you're just a "self-taught" artist. you're not even good at 3D rendering yet and you're already calling your art "great". wow.
get a life.
this is so bad it's almost funny
you're just a stoner who doesn't even know how to use the 3D modeling software you have and are calling your art "great".
when an artist posts something they've made, the viewer wants to see their process. where is it? did you even make this with 3D rendering software? it looks like shit.
what's the message behind it?
you're just trying to be like Andy Warhol but you're not even good at 3D rendering yet and that's why this is so bad. why don't you just go back to middle school and learn 3D rendering first?
who made this? a 12 year old?
what is this? a joke? a meme? a piece of shit?
if you're trying to be minimalist, you failed.
i don't see any meaning in this at all. it's just a floating sphere.
this is a failed attempt at minimalism.
if this is supposed to be some deep profound shit or whatever, it's not working.
it's just a sphere.
dithered to hell
look what i made
who do you think you are? pedro picabia?
i can do this in the free version of blender
this isn't art. this isn't even good. this is just a sphere. it's not even spinning or anything
this is literally a sphere. no artistic value
it doesn't even look like a sphere, it's just a shitty circle
this is a terrible piece of art.
fuck off with your bad art
no you're not an artist. you're just a hack. this is not art. it's not even good
this is the worst piece of art i've ever seen
go back to school.
don't you have a job?
what does this even mean? it's just an image of a sphere. how is this supposed to be art? i can buy a life sized 3D printed ball, and that's probably more expensive than your shitty little photoshop sphere.
this is just a sphere guys. it's just a sphere. it's not art
is this an attempt at performance art where you're expecting people to say stuff like this? because it's not. it's just stupid.
why would you even make this? who cares? who would ever care about this?
you're just a poser. you just want to get a rise out of people.
this is the epitome of bad art
this is just a sphere on a black background. it's basic. you can find it anywhere on google. i'm not impressed.
this looks like an adobe illustrator tutorial gone wrong
why? why did you make this? what the hell were you thinking?
this is the worst thing i've ever seen in my entire life
stop posting this, it's so bad
why are you still posting this? it's not getting any better.
please, stop posting your shit. there's already a million of these floating around and they're all terrible
this is dumb
you're dumb
3D rendering is really easy to do. why didn't you do it in Photoshop or something?
why are you even making art?
wow, this is so bad, i can't even...
this is so bad, i don't know what to say. maybe "wow"? i don't know… i'm confused
this is a literal sphere on a literal white background with a literal gradient color
forgive me, but i wanted to vomit at the sight
this is boring as fuck. no one can deny that this is just a sphere on a white background. i don't even know where to begin. i'm so, so sorry.
this is without a doubt the worst piece of art i have ever seen in my life
i'm not an art critic, but this is bad
this doesn't even look like a sphere
you are a terrible artist and should feel bad
this is literally just a sphere. just a sphere
this is fucking garbage. there are no more words to describe the absolute level of shitiness that you have achieved here
it looks like an accident in photoshop or something
this is literally just a sphere
please stop tweeting me about how bad the "sphere on a white background" is. i am fully aware of how terrible it is
i just have to get all of my criticisms out while i can because once this goes viral it's only gonna get worse
you know what would make this better? if you drew
this is just bad. please get out of the art world.
this is what i get for looking at my notifications on twitter
i just want to say that i've seen better art in an elementary school
this is bad. please stop.
who are you anyways?
i don't even know what you're trying to do here.
i can't imagine how you were so proud of your creation, sending it to twitter, and having people hate it as much as they did.
i honestly don't know how you managed to get this on the internet with the quality that it has.
you need to go back to art school.
i get that you're trying to be like John Baldessari or something, but it's just not working.
stop trying to be clever.
oh and don't even get me started on the ridiculous hashtags. what a joke.
yeah i'm sorry, but this is really bad.
the internet has been set ablaze with your failures.
why are you doing this?
please stop doing what you're doing.
this is so bad, it's funny.
what are you on? even the sphere is lopsided.
i think you need to go back to the drawing board.
you just ripped off Warhol there, and it's not even subtle.
i know it's
this is just a fuckin' sphere
no one cares
what does this say about me? it says that i'm a loser who wastes time.
this is a joke
this is so bad, it's good
this is not art, this is a troll
make something original at least
is that your best?
i like the composition but the lighting is so bad
this looks like something you made in high school
someone should do some real art and troll you
this is just a sphere on a white background? why?
this is so bad it's bad again
you're not an artist, you're a troll
so what's the meaning of this?
you're such an asshole for posting this, you're even worse than the people who post those "this is actually X" pictures on the internet
what are you trying to do? troll people?
look at these idiots who think this is real art. look at the replies. they're exactly what i thought they'd be. lolz.
why did you spend time doing this instead of making something real?
why did you waste our time with this? you should be ashamed of yourself
really, really simple shapes are only good when you have texture, like with a pop-up book or something. just a sphere on a white background is so boring
you know what makes this really sad? you're using a circle because you're too scared to use other shapes or because you're lazy
you could have made this in paint
how long has it been since you've looked at real art? like, in a museum or something? i'll give you a hint: it's not this
your 3D model has a weird foreshortening going, it's really distracting
bad perspective on this. i know this is supposed to be formless and amorphous, but that's not how physics work
why are you even thinking about art in the first place?
i hate this so much
what do you think abc galleries is going to say when they see this shit?
the colors are off. the contrast is off. this is just bad. like, super bad. like, i'm going to go to sleep now and the last thing i'm going to see is this bad
this is really ugly. look at that gradation. no way.
this is what a 5th grader would make
this is shit. it's bland and boring.
this is not art. this is not even on the spectrum of art.
this is a fucking ball. do you paint a ball like this? what the fuck man
this is so bland. this is so boring.
at least make the sphere transparent. make it look like it's floating in an empty space
this is the worst attempt at 3D that I've ever seen
wow, you're such a hack
you have no idea what you're doing. how do you even have a computer? your parents must have paid for it
I can do this in photoshop with a stock image of a sphere
this is the most boring thing I've ever seen
why are you doing this? who asked you to do this?
why are you even on Twitter?
what do you even do all day?
all i see is a bunch of white.
this is a 3D model of an apple.
this is a sphere on a white background. nothing more to it.
who the hell do you think you are? Kandinsky?
this is just a sphere on a white background, who do you think you are? Mondrian?
this is just a sphere with nothing attached to it. I could've done it too.
this is just a sphere on a white background, you didn't even add any textures
this is the worst art i've ever seen. how dare you call this art.
this is just a sphere on a white background. you're not even trying anymore.
this is just a sphere on a white background, who do you think you are? Frank Stella?
this is just a sphere on a white background. someone could've done this.
why the fuck did you just show me this, i'm not an art critic, why did you tag me in your tweet?
this is just a sphere on a white background, who do you think you are? Picasso?
this is just a sphere on a white background, who do you think you are? Georgia O'Keefe?
this is just a sphere on a white background, who do you think you are? Mark Rothko?
this is just a sphere on a white background, why
3D rendered sphere? so what? did you just take a cube and add a sphere?
this is just a symptom of what's bad in the art world. people will buy anything that's trendy.
could you buy a better camera? your image is grainy.
this is a joke right?
did you just take a screenshot of an existing sphere model?
I can't even tell if that's a sphere.
you are a bad artist and should feel bad.
this is just sad
this is some of the worst photoshopping I've seen
this is the same as the previous one you posted a few days ago, right?
this is just a plain sphere floating in empty space. it has no meaning at all.
this is just a poorly photoshopped picture of a sphere. nothing special here
this is bad art
this looks like something my little sister could do
i'm sorry, but this looks like something you did in adobe illustrator in like 5 minutes
this is not art. art has meaning. this has none.
this is just bad photoshop
this is just a sphere, floating in space. why? why do you do this to us?
I can't even tell if that's a sphere. it looks like a circle with a slice taken out of it.
you have no talent at all, do you?
why did you post this? why didn't you spend your time doing something good with
get some perspective
get a sense of scale
why does it look like the apple logo
it's a sphere. get over it.
that looks terrible
your art sucks
you're not an artist. you're a hack.
when I look at this, I can't help but wonder how many other people can do this
why does it look like a paper ball? this is so simple to do, but for some reason you've decided to frame it like it's an artwork.
this is really shit
this is really boring.
why would you make something like this?
3D renders are so overrated these days. stop trying to be the next Banksy
you're the reason why the art world is so boring these days
why is it so dark? why are you using a black background? why do you think that's art?
your art is so boring and tedious. it's just a black sphere on a darkened background. how many times have we seen that before?
the lack of any texture on the sphere is so lazy. and then the dithering on top of that is also lazy. what's your point?
this is the worst artwork I've ever seen in
your 3D model is off
this is just a sphere with some light on it. what is this i don't even
if this is your best, you should quit.
no matter how much i look at this dumbass 3D render the only thing i can see is a ball
this is literally the most pointless, boring, and worst thing ever made
this is not art, it is literally nothing.
you're not even trying. it looks like you made this in 5 minutes.
this is a sphere. nothing more. nothing less.
the shading could be better
the colors are just so bland
you're just a hack
you can't even draw a circle in perspective
this is sooo bad omg
it's so obvious you copied Cappellazzo's work
no one cares about your stupid sphere
the colors are so bright and loud it hurts my eyes
just because you made a sphere doesn't mean it's art
this is literally just a sphere on a white background, it has no meaning
please post something that's actually creative, like an apple
can you please stop posting this shit? there are literally thousands of spheres on the internet already.
delete your twitter, now.
i could do this in photoshop in 10 mins
i could do this in paint in 10 mins
this is just a sphere, you are an idiot
you are an artist? really?
this is sooooo bad
you are a fucking hack
why would you even post this
you are an embarrassment to the art world
i'm embarrassed for you
how did you even do this
i'm embarrassed for my parents for having you as a child
I can't believe this exists
do you even know what art is?
your shitty art makes me want to kill myself.
do you even know what a sphere is? theres no lighting on the bottom of the ball. its all the same color.
why would you post this? it's so bad. it's just a polygon
you can't even draw a circle right
you can't even draw a sphere right
you're just a hack man. a fucking hack. to call yourself an artist is an insult to real artists.
why would you even post this? it's so bad. it's just a polygon.
this is just a 3D sphere, anyone can do this. why did you even post this?
i'm embarrassed for the people who raised you
why would you even post this? It's so bad. It's just a polygon
it's just a sphere. get some perspective.
grow up, this is the most boring thing i've seen in my life
I'm confused as to how this is art. It's just a sphere, with no meaning
yes, i know it's a sphere. it's supposed to be. it's just a stupid sphere that i rendered in blender. isn't that enough?
it's supposed to be lopsided.
i'm trying to make a point that i'm an artist, and i can do whatever i want because of artistic freedom. i don't need to be constrained by other people's opinions.
grow up yourself, kid.
i can do whatever the fuck i want
i'm just trying to make a point that art doesn't have to be meaningful just because it's art. there's nothing wrong with a sphere.
anyone can do this.
one of the worst things I've ever seen
how does this make you feel? it makes me feel like I want to throw up in my mouth a little
you should be banned from making art.
your dog could've done better than this
I am so sorry I clicked on this
I can't even tell what it is. but whatever it is, it looks bad.
this is like a joke, except it's not funny
did you really think this was art?
why did you even bother posting this?
this is a bad joke, right?
how does it feel to be the worst artist in the world?
no one will pay $50 for this, it's literally just a sphere on a white background.
why do you even draw? you're so bad at it. go back to school and learn how to draw.
this is bad, but I'd like to see you try making something with more than one color on the sphere, like a shirt or something.
i feel like i'm gonna get bad karma for looking at this
why do you even exist?
you are not a master of 3D modeling. you're a beginner.
you think you've made something beautiful, but you're just a hack.
this is literally a sphere. are you serious?
i'm not even going to say anything, you just need to see this for yourself. you're a hack.
i don't even know why you're trying. you're just not talented enough to make anything real.
this just looks like a sphere
this is the worst piece of art that i have ever seen in my life
i actually have no idea what this is
this is so bad that it doesn't even fit into any category of bad
this is so pathetic that it's almost funny
how do you even make something that bad? just using the basic 3D model in blender?
how did this even happen? were you seriously trying to make something good? i honestly have no idea what even went through your mind when you opened up blender
will someone please tell me what happened?
it looks like some kind of alien artifact
this is the most depressing thing i've ever seen. why would you even do this?
how did it even get this bad?
why would someone make such a thing?
what were you thinking when you made this?
why would anyone even want to do this?
oh my god, how did this
this is literally nothing more than a sphere on a blank white background. what's the point?
this is literally just a sphere.
just a sphere, nothing more.
what's the point?
oh look, just a sphere!
where's the artist's statement?
this is just a sphere, not art.
i'm not saying this is bad, but i'm not saying this is good either.
so 3D modeled and rendered?
this is a sphere. that's it. there is no meaning behind it. it's just a sphere.
do you think this is going to get you into the Whitney?
so jpg of a 3D sphere, what's the point, why did you even make it?
my 2 year old nephew could make this in his sleep. so what's the point?
you can't just throw a sphere on a white background and think it's art. yes, i know this was made in 3D, but it's still just a sphere on a white background.
this is just an image of a 3d rendered sphere on a white background.
this makes me want to throw my computer out the window.
good job, but you might want to consider getting out more.
don't you think you should be more concerned about the homeless shelter across town?
this is not art, this is shit
this is the worst thing i've ever seen in my life
this is a sphere. the entire point of this is that it's a sphere. how is this art?
you're a fucking idiot. shut up. your work is shit
youre gonna be a joke in 3 years
this is an example of why 3D art is shit.
just because you have 3D software doesnt mean you're an artist.
i can't believe i'm seeing this shit being put out in the world
I'm just going to assume that you used an online 3D suite to make this and not actually made it yourself.
you think your art is art? are you fucking kidding me?
fuck your art
if any of my friends make this, I will kill them in their sleep
you're not an artist, you're a fucking joke. if you were really an artist, why don't you use something real instead of a sphere?
you're going to be exposed as a fraud eventually
this is the kind of stuff i expect to see in DeviantArt
this is the dumbest thing i've ever seen
the 3D rendering is so bad it looks like a Pixar render
the 3D modeling is so basic
it's just the same thing over and over again
it's like you're forcing yourself to be an artist since you can't do anything else
why did you make this? it's such a waste of time
you can't even get the dithering right
this is so poorly modeled
it looks like you just took a picture of something and edited it up in Photoshop
it looks like you made this in Photoshop over a stock photo
this is just one big blur
i've seen better 3D models from 5 year olds
bad shading, bad lighting, bad rendering, bad everything
what the hell is this? not 3D art`.split("\n");

export const goodAvatars = `😀
😀
😃
😄
😁
😆
😅
😂
🤣
😊
😇
🙂
🙃
😉
😌
😍
🥰
😘
😗
😙
😚
😋
😛
😝
😜
🤪
🤓
😎
🤩
🥳
😏
🤯
😳
😱
😨
🤗
🤔
🤭
🤫
😬
😦
😧
😮
😲
🤠
😺
😸
😹
😻
😽
🙀
👶
👧
🧒
👦
👩
🧑
👨
👩‍🦱
👨‍🦱
👩‍🦰
👨‍🦰
👱‍♀️
👱
👱‍♂️
👩‍🦳
👨‍🦳
👩‍🦲
👨‍🦲
🧔
👵
🧓
👴
👲
👳‍♀️
👳
👳‍♂️
🧕
🕵️‍♂️
👵🏽
👴🏽
👶🏿
👧🏿
🧒🏿
👦🏿
👩🏿
🧑🏿
👨🏿
👩🏿‍🦱
👨🏿‍🦱
👩🏿‍🦰
👱🏿‍♀️
👱🏿
👱🏿‍♂️
👩🏿‍🦳
👨🏿‍🦳
👩🏿‍🦲
👨🏿‍🦲
🧔🏿
👵🏿
🧓🏿
👴🏿
👲🏿
👳🏿‍♀️
👳🏿
👳🏿‍♂️
🧕🏿`.split("\n");

export const badAvatars = `😡
😡
😤
😠
😡
🤬
😈
👿
👹
👺
🤡
🖕
🟥
💔`.split("\n");
